export default {
	demo_account:{
        footerpoint1:`Fxview is the trading name of the Fxview group of companies which consists of:`,
        footerpoint2:`- Parent company, Finvasia Securities Private Ltd, regulated by the Securities and Exchange Board of India (Licence No INZ000176037)`,
        footerpoint3:`- Charlgate Ltd, regulated by the Cyprus Securities and Exchange Commission (Licence No 367/18)`,
        footerpoint4:`- Charlgate SVG LLC (Reg. No. 1112 LLC 2021) with registered address at First Floor, First St Vincent Bank Ltd Building, James Street, Kingstown, Saint Vincent and the Grenadines.`,
        footerpoint5:`- Nevea Services Ltd (Reg. No. 422664) with registered address at 319, 28th October Street, Kanika Business Center, Office 201B, Limassol 3105, Cyprus.`,
        footerpoint6:`The merchant company is Nevea Services Ltd with registered address at 319, 28th October Street, Kanika Business Center, Office 201B, Limassol 3105, Cyprus. The merchant company provides content, administrative services, payment processing and safekeeping services.`,
        footerpoint7:`Clients must be at least 18 years old to use the services of Fxview.`,
        footerpoint8:`Trading complex instruments on margin carries a high level of risk and may not be suitable for all investors. Before deciding to trade, you should carefully consider your trading objectives, level of experience and risk appetite. It is possible for you to sustain losses that exceed your invested capital, and therefore you should not deposit money that you cannot afford to lose. Please ensure you fully understand the risks and take appropriate care to manage them.`,
        footerpoint9:`This site contains links to websites controlled or offered by third parties. Fxview has not reviewed and hereby disclaims responsibility for any information or materials posted at any of the sites linked to this site. By creating a link to a thirdparty website, Fxview does not endorse or recommend any products or services offered on that website. The information contained on this site is intended for informational purposes only. Therefore, it should not be regarded as an offer or solicitation to any person in any jurisdiction in which such an offer or solicitation is not authorized or to any person to whom it would be unlawful to make such an offer or solicitation, nor regarded as recommendation to buy, sell or otherwise deal with any particular trade. If you are not sure about your local trading regulations, then you should leave this site immediately.`,
        footerpoint10:`You are strongly advised to obtain independent financial, legal and tax advice before proceeding with any trade. Nothing on this site should be read or construed as constituting advice on the part of Fxview or any of its affiliates, directors, officers or employees.`,
        footerpoint11:`The services of Fxview and the information on this site are not directed at residents of the Crimea, Cuba, Cyprus, India, Iran, North Korea, Sudan, Syria, and the United States and are not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.`,
        high_risk_warning:'High Risk Warning',
        open_a:'Open a',
        free_demo:'Free Demo',
        account_on:'Account',
        mt4:'MetaTrader 4',
        mt5:'MetaTrader 5',
        act:'ActTrader',
        or:'or',
        register:'Register',
        login:'Login',
        have_acc:'Have an account?',
        register_form:{
            otp_msg:'One-Time Pin has been sent to your email. Please enter it below.',
            open_an_account:'Open an Account',
            will_take_minut:'It will take less than a minute',
            select_residence_country:'Select Residence Country',
            email:'Email Address',
            pass:'Enter Password',
            cpass:'Confirm Password',
            privacy_agree:'By Signing up you agree to our',
            privacy_policy:'Privacy Policy',
        },
        website_use:'Website Use',
        cookies_policy:'Cookies Policy',
	    refund_policy:'Refund Policy',
	    AML_policy:'AML Policy',
        sub_heading1:{
            our:'Our',
            features:'Features',
            title:`Unleash your trading potential and conquer the market with our unbeatable trading conditions.`,
            sub_container1:{
                in_depth:'In-depth',
                learning:'Learning',
                description:'Enhance your trading by signing up to our free webinars and learn from experts. Our webinars are specifically designed to boost your market knowledge and hone your trading skills.',
            },
            sub_container2:{
                risk_free:`Risk-free`,
                trading:'Trading',
                description:`Whether you're new to trading or already an experienced forex trader, discover your trading prowess at Fxview, with our risk-free forex demo account.`,
            },
            sub_container3:{
                hundreds_of:'Hundreds of',
                tradable_instruments:'tradable instruments',
                description:'Gain access to over 500 trading products ranging from Fx to Commodities, Stocks, Indices, and digital assets.',
            },
            sub_container4:{
                real_prices_with:'Real prices with',
                fast_execution:'fast execution',
                description:'Experience real-time trading, explore a plethora of tools and strategies, and sharpen your skills all while trading in a completely risk-free demo account.',
            },
        },
        sub_heading2:{
            frequently_asked:'Frequently Asked',
            questions:'Questions',
            description:`Get Your Questions Answered: Your Ultimate Guide.`,
            more_info:'More Info',
            faq1:{
                question:`Is there a time limit to using a demo account?`,
                answer:`You can use the demo account for as long as you wish. The account only gets deactivated if there is no activity for 30 consecutive days.`,
            },
            faq2:{
                question:`Can I open multiple demo accounts with different trading platforms?`,
                answer:`Yes, you can. There is no limit on the number of demo accounts one can open with different platforms.`,
            },
            faq3:{
                question:`What’s the difference between a demo and live trading account?`,
                answer:`Live trading accounts need to be funded with real money for placing trades. Whereas demo accounts are funded with virtual money to eliminate the risk of losing real money. Other than this the trading conditions, tools, and features are almost the same for both demo and live accounts.`,
            },
            faq4:{
                question:`What’s the maximum amount I can trade in a demo account?`,
                answer:`You will get $100,000 to trade in the demo account. This amount gets refilled once the balance goes nil.`,
            },
            faq5:{
                question:`Can I practice CFD trading in a demo account?`,
                answer:`Yes, you are free to trade any instrument that we offer for live trading on your demo account.`,
            },
            faq6:{
                question:`Can I open multiple demo accounts?`,
                answer:`Yes, you can open multiple demo accounts with different platforms. But only one demo account can be opened for each type of account.`,
            },
            faq7:{
                question:`Is there an inactivity fee on demo account?`,
                answer:`No, we don’t charge any inactivity fee, but the demo account will be deactivated if not used for 30 consecutive days.`,
            },
        }
    },
	
	"financial_details": 'Detalhes Financeiros',
	"reg_step_one_point": "Se empregado, por favor especifique",
	"reg_step_one_point_two": "Receita Anual Estimada (USD)",
	"reg_step_one_point_three": "Patrimônio Líquido Estimado (USD)",
	"reg_step_one_point_four": "Fonte de renda",
	"accountancy": "Contabilidade",
	"admin_secretarial": "Administrador/Secretária",
	"auctions": "Leilões",
	"catering_hospitality": "Restauração/Hospitalidade",
	"creative_media": "Criativo/Mídia ",
	"education": "Educação",
	"emergency_services": "Serviços de emergência",
	"engineering": "Engenharia",
	"financial_services": "Serviços financeiros",
	"gas_petrol": "Gás/Gasolina",
	"health_medicine": "Saúde/Medicina",
	"army_industry": "Exército/Indústria do Exército",
	"hr": "RH",
	"insurance": "Seguro ",
	"legal": "Jurídico",
	"leisure_tourism": "Lazer/Turismo ",
	"manufacturing": "Manufatura ",
	"marketing_pr_advertising": "Marketing/RP/Publicidade",
	"pharmaceuticals": "Produtos farmacêuticos ",
	"precious_metals_Diamonds": "Metais preciosos/Diamantes",
	"property_construction_real_state": "Construção Imobiliária/Imóveis ",
	"retail": "Varejo",
	"sales": "Vendas",
	"social_care_services": "Assistência Social/Serviços ",
	"telecommunications": "Telecomunicações",
	"transport_logistics": "Transporte/Logística ",
	"trust_charities_foundations": "Trust/Instituições de caridade/Fundações ",
	"virtual_currency": "Moeda virtual",
	"other_please_specify": "Outro (por favor, especifique)",
	"till_ten_thousand": "0-10.000",
	"till_fifty_thousand": "10.000-50.000",
	"till_one_lac":"50.000-100.000",
	"till_two_lac": "100.000-200.000" ,
	"above_two_lac":"Acima de 200.000",
	"till_fiftythousand": "0-50.000",
	"till_fiftythousand": "50.000-100.000",
	"till_three_lac": "100.000-300.000",
	"above_three_lac": "300.000+",
	"employment": "Emprego",
	"inheritance": "Herança",
	"investment": "Investimento",
	"real_estate": "Imobiliário" ,
	"savings": "Poupança",
	"other": "Outro",
	"reg_step_three": "Vamos testar sua experiência de negociação.",
	"reg_step_three_point": "Como entidade regulamentada, somos obrigados a avaliar se você tem conhecimento adequado para negociar produtos alavancados. Por favor, complete seu teste de adequação com cuidado, pois suas respostas serão usadas para determinar se você pode abrir uma conta de negociação ao vivo conosco.",
	"start_test": "Iniciar Teste",
	"depMsz1": "Tempo de Processamento",
	"depMsz2": "1 a 5 dias úteis",
	"depMsz3": "Taxa",
	"depMsz4": "0",
	"depMsz10": "Instantâneo 24 horas por dia, 7 dias por semana",
	"MiniDepositAmount": "Valor mínimo de depósito",
	"DntSkill": "Você não tem nenhum ID Skrill, por favor",
	"depMsz12": "para alterar o seu ID Skrill",
	"netId": "Netteller Id",
	"depMsz13": "Não é a conta Neteller certa? Por favor",
	"depMsz14": "Para alterar o seu Neteller ID",
	"Clickhere": "Clique AQUI.",
	"DntNetteler": "Você não tem nenhum Netteller ID, por favor",
	"Tocreate": "criar.",
	"conPay": "Confirmar Depósito",
	"depMsz15": "Por favor, certifique-se de que os detalhes do depósito estão corretos. Se você estiver satisfeito com tudo, clique no botão 'Financiar agora' para prosseguir. Por favor, note que se você fizer um saque depois de depositar em sua conta, seus fundos provavelmente serão devolvidos para o mesmo método usado para depositar.",
	"accountId": "ID da conta",
	"feeUsd": "Taxa (USD)",
	"depositAmount": "Valor do depósito",
	"paymentMethod": "Método de Depósito",
	"backToStep": "Etapa anterior",
	"procToPay": "Proceder ao pagamento",
	"personalInfo": "Informações Pessoais",
	"fname": "Primeiro Nome",
	"lname": "Sobrenome",
	"InvalidNumber": "Número inválido",
	"saveContinue": "Salvar & Continuar",
	"termsAgreeRqd": "Por favor, concorde com os termos para prosseguir",
	"googleOtp": "Insira a senha única mostrada no aplicativo <strong>Google Authenticator</strong>.",
	"enterAmount": "Insira o valor",
	"allowDeposit1lac": "não estamos permitindo depósito superior a 1,00,000 para conta demo",
	"SearchSomething": "Pesquise aqui",
	"search": "Pesquisar",
	"Prev": "Anterior",
	"Next": "Próximo",
	"PleaseEnsureCorrect": "Por favor, certifique-se de que os detalhes estão corretos",
	"lg_riskWarningMsg": "Os CFDs são instrumentos complexos e vêm com um alto risco de perder dinheiro rapidamente devido à alavancagem. A grande maioria das contas de clientes de varejo perdem dinheiro ao negociar em CFDs. Você deve considerar se entende como os CFDs funcionam e se pode se dar ao luxo de assumir o alto risco de perder seu dinheiro.",
	"lg_welcomeMsgHeadone": "Condições Comerciais Competitivas",
	"lg_welcomeMsg1": "Beneficie-se de spreads tão baixos quanto 0,0 pips nos principais pares de câmbio e comissão de US$ 1 por US$ 100.000 por lado.",
	"lg_welcomeMsgHeadtwo": "Nossas Plataformas",
	"lg_welcomeMsg2": "Acesse os mercados mais populares do mundo em nossas plataformas rápidas e confiáveis - MT4, MT5 e ActTrader",
	"lg_welcomeMsgHeadthree": "Ferramentas de Negociação",
	"lg_welcomeMsg3": "Acesse uma ampla gama de ferramentas de negociação, como Autochartist, Trader's Tool Box, negociação API e muito mais",
	"lg_signin": "Faça login no Fxview",
	"lg_emailaddress": "Endereço de e-mail",
	"lg_EmailfieldValid": "Introduza um endereço de e-mail válido",
	"lg_EmailfieldReq": "O campo Email é obrigatório",
	"lg_password": "Senha",
	"lg_logIn": "Entrar",
	"lg_forgotPassword": "Esqueci minha senha",
	"lg_donthaveaccount": "Não tem conta?",
	"lg_signuphere": "Inscreva-se aqui",
	"lg_charlgateMsGlobal": "Empresa Finvasia Capital (PTY) Ltd registrada na África do Sul com o número de empresa 2018/303451/07. O endereço da sede social é 3rd Floor, 34 Whiteley Blvd, Melrose Arch, Birnam, 2196.",
	"lg_charlgateMsEurope": "Charlgate Ltd é autorizada e regulada pela CySEC, com o número de licença 367/18 e o número de registo da empresa 372060.",
	"lg_varify2step": "Verificação em duas etapas",
	"lg_EnterAuthCode": "Digite o código de autenticação",
	"lg_submit": "Submeter",
	"lg_backLogin": "Voltar ao login",
	"lg_footerMsz2": "Seu capital está em risco. Você pode perder todo o capital investido.",
	"lg_riskDisclaimer": "Isenção de responsabilidade de risco",
	"fp_forgotPasswordText": "Por favor, digite seu endereço de e-mail registrado com fxview para que possamos ajudá-lo a criar uma nova senha.",
	"fp_resetPassword": "Redefinir senha",
	"fp_RESEND_EMAIL": "Reenviar e-mail",
	"fp_backLogin": "Voltar à página de login",
	"fp_charlgateMsg": "A Charlgate Ltd é proprietária fxview.com. Charlgate Ltd é uma empresa autorizada e regulada pela Cyprus Securities and Exchange Commission – CySEC (CySEC Licence number 367/18 & número de registro da empresa",
	"reg_welcomemsg1": "<h3>Spreads</h3><p>de 0,0 pip</p>",
	"reg_welcomemsg2": "<h3>$1 per</h3><p>$100K Comissão</p>",
	"reg_welcomemsg3": "<h3>Uma variedade de</h3><p>Ferramentas de negociação</p>",
	"reg_welcomemsg4": "<h3>Ultra</h3><p>Execução rápida</p>",
	"reg_welcomemsg5": "<h3>100%</h3><p>Bónus de Depósito",
	"reg_openacc": "Abra uma conta",
	"reg_takeminute": "Vai demorar menos de um minuto",
	"reg_selectacctype": "Selecione o tipo de conta",
	"reg_selectcountry": "selecione o país de residência",
	"reg_Enterfname": 'Introduza o primeiro nome',
	"reg_Entername": 'Digite seu nome',
	"reg_Enterlname": 'Insira o último nome',
	"reg_Enteremail": "Digite o endereço de e-mail",
	"reg_Enterpwd": "Digite a senha",
	"reg_passwordFieldReq": "O campo de senha é obrigatório",
	"reg_passCharVal": "Sua senha deve conter pelo menos 6 caracteres e incluir pelo menos 1 número, 1 caractere maiúsculo e 1 caractere especial (!@#$%^*)",
	"reg_conPassword": "Confirmar senha",
	"reg_ConfpasswordReq": "O campo confirmar senha é obrigatório.",
	"reg_newConfFieldSame": "As senhas digitadas não coincidem. Por favor, tente novamente",
	"reg_captchaErr": "Captcha inválido",
	"reg_register": "Cadastre-se",
	"reg_signagree": "Ao se inscrever você concorda com o nosso",
	"reg_privacyPolicy": " Política de Privacidade",
	"reg_haveAccount": "Tem uma conta?",
	"reg_login": "Entrar",
	"reg_registerMsz2": "O One-Time Pin foi enviado para o seu e-mail. Por favor, insira-o abaixo.",
	"reg_enterOtp": "Entre na OTP",
	"reg_submit": "Submeter",
	"reg_resendotp": "Reenviar OTP",
	"rp_passwordHashMsz2": "A senha foi alterada com sucesso. Clique",
	"rp_here": "Aqui",
	"rp_toLogin": "para iniciar sessão",
	"rp_otherWayHelp": "Outras formas de obter ajuda",
	"rp_chatWithUs": "Converse com a gente",
	"rp_or": "ou",
	"rp_callUs": "Ligue para nós",
	"prof_verified": "Verificado",
	"prof_undrreview": "A sua candidatura está em análise!",
	"prof_checkstatus": "Por favor, verifique o status do seu bilhete",
	"prof_clickhere": "Clique Aqui",
	"prof_completeRegister": "Cadastro Completo",
	"prof_basicDetail": "Informações básicas",
	"prof_addressDetail": "Informações de endereço",
	"prof_paymentDetail": "Detalhes de pagamento",
	"prof_documents": "Documentos",
	"prof_fname": "Primeiro Nome",
	"prof_lname": "Sobrenome",
	"prof_DOB": "Data de nascimento",
	"prof_phone": "Telefone",
	"prof_Member": "Membro",
	"prof_companyname": "Nome da Empresa",
	"prof_incorporationdate": "Data de constituição",
	"prof_currency": "Moeda",
	"prof_emailaddress": "Endereço de e-mail",
	"prof_PEP": "Pessoa Politicamente Exposta (PEP)",
	"prof_addressLine1": "Endereço Residencial linha 1",
	"prof_addressLine2": "Endereço Residencial linha 2",
	"prof_postCode": "Código Postal",
	"prof_city": "Cidade ou Vila",
	"prof_resCountry": "País de residência",
	"prof_bankName": "Nome do banco",
	"prof_AccNumber": "Número da conta",
	"prof_Pending": "Pendente",
	"prof_Disable": "Desativar",
	"prof_viewDetail": "ver detalhe",
	"prof_paymentMethod": "Método de Depósito",
	"prof_AccountName": "Nome da conta",
	"prof_SwiftCode": "Swift/BIC/Código de classificação",
	"prof_IBAN": "IBAN",
	"prof_bankAdd": "Endereço do banco",
	"prof_onlinePayId": "ID de pagamento on-line",
	"prof_Change": "Mudança",
	"prof_CreditCard": "Número do cartão de crédito",
	"prof_ExpiryDate": "Prazo de validade",
	"prof_noBankDetail": "Sem dados bancários",
	"prof_AddBank": "Adicionar Banco",
	"prof_AddCard": "Adicionar cartão de crédito",
	"prof_noDocuments": "Sem documentos",
	"prof_disablecard": "Por favor, desative meu método de pagamento com cartão de crédito, informações conforme indicado abaixo",
	"prof_creditcardno": "Número do cartão de crédito",
	"prof_bankpaymentmethod": "Por favor, desative meu método de pagamento por transferência bancária, informações conforme indicado abaixo",
	"prof_diablepaymentmethod": "Desativar Método de Pagamento",
	"prof_addpeymentmethod": "Adicionar Forma de Pagamento",
	"twoFA_faText": "Autenticação de dois fatores",
	"twoFA_alreadyEnabled": "Habilitado",
	"twoFA_setUp2FA": "Configurar 2FA",
	"twoFA_clickToDisable": "Clique para desativar",
	"twoFA_clickToEnable": "Clique para ativar",
	"twoFA_enable2FaText": "Ativar autenticação de dois fatores",
	"twoFA_accounntSafe3Steps": "Torne sua conta mais segura em 3 passos fáceis",
	"twoFA_downloaduthApp": "Baixe um aplicativo autenticador",
	"twoFA_downloaduthAppText": "Baixe e instale o Authy ou o Google Authenticator em seu telefone ou tablet.",
	"twoFA_scanQrCode": "Digitalize o QR Code",
	"twoFA_scanQrCodeText": "Abra o aplicativo de autenticação e digitalize a imagem para a esquerda, usando a câmera do seu telefone.",
	"twoFA_loginYourCode": "Faça login com seu código",
	"twoFA_enter6DigitCode": "Digite o código de verificação de 6 dígitos gerado.",
	"twoFA_activate": "Ativar",
	"twoFA_enterOtpDisableQrCode": "Por favor, digite OTP para desativar o código QR",
	"twoFA_disableCodeText": "Desativar com seu código",
	"cp_changePassword": "Alterar senha",
	"cp_oldpwd": "Senha antiga",
	"cp_newPassword": "Nova Senha",
	"cp_conPassword": "Confirmar senha",
	"cp_passCharval": "Sua senha deve conter pelo menos 6 caracteres, no máximo 15 caracteres e incluir pelo menos 1 número, 1 caractere maiúsculo e 1 caractere especial (!@#$%^*)",
	"welcm_fewStepAway": "Você está a poucos passos de distância",
	"welcm_activateFxviewAccountNow": "Ative sua conta Fxview agora!",
	"welcm_setupFxViewAcc": "Configure sua conta fxview",
	"welcm_modify": "Modificar",
	"welcm_addFund": "Adicionar fundos",
	"welcm_startTrading": "Comece a negociar",
	"welcm_welcomeFxView": "Bem-vindo à Fxview!",
	"welcm_welFxviewCon": "Você está quase pronto para começar a negociar. Por favor, preencha o seu pedido de conta de negociação e carregue os documentos de identificação necessários.",
	"welcm_completeReg": "Cadastro Completo",
	"welcm_tryDemoAcc": "Experimente uma conta demo",
	"welcm_tryDemoAccCon": "Experimente nossas plataformas de negociação - MT4, MT5 e ActTrader - e desenvolva suas habilidades de negociação de CFD. Pratique negociação com fundos virtuais",
	"welcm_createDemoAccount": "Conta Demo",
	"welcm_downloadPlatform": "Plataforma de Download",
	"welcm_MT4": "Meta Trader 4",
	"welcm_winIosAndroid": "Windows/IOS/Android",
	"welcm_MT5": "Meta Trader 5",
	"welcm_actTrader": "ActTrader<sup>TM</sup>",
	"welcm_rangeTradTools": "Gama de Ferramentas de Negociação",
	"welcm_wlcmMsz1": "Identificar ideias de negociação geradas automaticamente com base em padrões gráficos, breakouts, reversões de tendência, padrões de Fibonacci e indicadores técnicos.",
	"welcm_wlcmMsz2": "Explore uma ampla gama de ideias de negociação acionáveis reconhecidas com base em vários padrões gráficos e indicadores técnicos em várias classes de ativos.",
	"welcm_wlcmMsz3": "Fique um passo à frente com notícias financeiras em tempo real e atualizações sobre eventos geopolíticos para tomar decisões de negociação informadas.",
	"welcm_wlcmMsz4": "Mantenha-se atualizado com o calendário econômico em tempo real que engloba os principais eventos e indicadores econômicos globais no horizonte.",
	"welcm_wlcmMsz5": "Obtenha uma experiência de negociação incomparável através do programa de hospedagem VPS adequado que permite que você negocie ininterruptamente com latência reduzida.",
	"welcm_SeeMore": "Veja mais",
	"notif_Notification": "Notificação",
	"notif_noNewNotification": "Sem novas notificações",
	"verf_reqProcessing": "processamento de pedidos...",
	"verf_reqVerify": "Solicitar verificação",
	"verf_dear": "Querido",
	"verf_requestVerifyWith": "O seu pedido de levantamento foi processado com sucesso",
	"verf_backWithList": "Voltar à lista de levantamentos",
	"verf_reqFailed": "Falha na solicitação",
	"verf_msg": "O seu pedido de levantamento falhou",
	"refer_Refera": "Indique um ",
	"refer_friend": "Amigo",
	"refer_opportunity": "Nosso programa indique um amigo lhe dá a oportunidade de ganhar US $ 20 para cada amigo que você indicar. Além disso, seu amigo também será recompensado com US $ 20 quando se inscrever com seu e-mail de convite.",
	"refer_Refernow": "Consulte agora",
	"refer_howorks": "Como funciona",
	"refer_everyclient": "Para cada cliente que você indicar, vamos recompensá-lo com US $ 20. Compartilhe suas coisas favoritas sobre fxview com seus amigos e aproveite a margem de negociação adicional, em nós.",
	"refer_stepmsg1": "Registe-se ou inicie sessão na sua conta fxview",
	"refer_stepmsg2": "Convide seu amigo usando o formulário na área do cliente",
	"refer_stepmsg3": "Seu amigo receberá um convite por e-mail e seguirá os passos para se cadastrar",
	"refer_stepmsg4": "Tanto você quanto seu amigo receberão US$ 20 quando você e seu amigo depositarem US$ 200 ou mais na conta deles",
	"refer_referEmail": "E-mail encaminhado",
	"refer_addmore": "Adicione mais",
	"refer_nowrefer": "Consulte agora",
	"refer_successRefer": "Você se referiu com sucesso",
	"refer_refrMore": "Consulte mais",
	"refer_godashboard": "Ir para o Dashboard",
	"refer_partnerprog": "Nosso outro programa de parceria",
	"refer_Affilialte": "Programa de Afiliados",
	"refer_uniquelink": "Obtenha seu link de referência exclusivo",
	"refer_trackearn": "Acompanhe seus ganhos com indicações",
	"refer_monitorStatus": "Monitore o status de suas referências",
	"refer_withdrawearn": "Retire seus ganhos como desejar",
	"refer_register": "Cadastre-se",
	"refer_knowmore": "Saiba Mais",
	"refer_brokerprogram": "Apresentando o Programa Corretor",
	"refer_uniqueIB": "Portal IB único",
	"refer_IBmanager": "Gerente IB dedicado",
	"refer_controlearn": "Assuma o controle de seus ganhos",
	"refer_regislink": "link único de inscrição IB",
	"refer_clientlist": "Lista de Clientes",
	"refer_email": "E-mail",
	"refer_accountStatus": "Estágio da conta",
	"refer_volumereq": "Necessidade de volume",
	"refer_tradedvol": "Volume Negociado",
	"refer_qualified": "Qualificado",
	"refer_action": "Ação",
	"refer_successDelete": "Você excluiu com êxito",
	"refer_fromReflist": "da sua lista de referências",
	"refer_wantTodelete": "Você quer excluir",
	"refer_confrm": "Confirme",
	"refer_enterEmailrefer": "Por favor, digite o e-mail para consultar",
	"refer_error": "erro",
	"refer_errorReferal": "Você deve ser verificado e financiado antes do encaminhamento.",
	"dash_overview": "Visão geral",
	"dash_traderRoom": "Sala do Trader",
	"dash_personalInfo": "Informações Pessoais",
	"dash_declaration": "Declaração",
	"dash_uploadDocumen": "Carregar documentos pessoais",
	"dash_completeReg": "Cadastro Completo",
	"dash_checkticketstatus": "Por favor, verifique o status do seu bilhete.",
	"dash_clickhere": "Clique Aqui",
	"dash_TradingAcc": "Contas de Negociação",
	"dash_live": "Ao vivo",
	"dash_demo": "Demonstração",
	"dash_Platform": "Plataforma",
	"dash_tradAccId": "ID da conta",
	"dash_Leverage": "Alavancagem",
	"dash_currency": "Moeda",
	"dash_marketSummary": "Resumo do Mercado",
	"dash_marketInsight": "Insights de Mercado",
	"dash_news": "Notícias",
	"dash_EconomicCal": "Calendário Econômico",
	"dash_thereIsNoRecord": "Nenhum registro encontrado",
	"dash_Time": "Tempo",
	"dash_Country": "País",
	"dash_event": "Evento",
	"dash_frequency": "Frequência",
	"dash_autochartist": "Autocartista",
	"dash_nodata": "Sem dados",
	"dash_time": "Tempo",
	"dash_impact": "Impacto",
	"dash_actual": "Real",
	"dash_forecast": "Previsão",
	"dash_previous": "Anterior",
	"dp_download": "Baixar",
	"dp_actTrader": "ActTrader<sup>TM</sup>",
	"dp_forWindows": "Para Windows",
	"dp_forIos": "Para iOS",
	"dp_forAndroid": "Para Android",
	"dp_ActWebTrader": "Ato Web Trader",
	"dp_MT4WebTrader": "MT4 Web Trader",
	"dp_forMAC": "Para MAC",
	"dp_MT5WebTrader": "MT5 Web Trader",
	"forWindows": "Janelas",
	"forIos": "iOS",
	"WEB": "Web",
	"acc_Aclist": "Lista de contas",
	"acc_changeLeverage": "Alavancagem de Mudança",
	"acc_changeplatPass": "Alterar senha da plataforma",
	"acc_InternalTrans": "Transferência interna",
	"bnk_bankDetails": "Dados Bancários",
	"bnk_MicrCode": "Código Micr",
	"bnk_IBANNumber": "Número de Conta IBAN",
	"bnk_ifscSwiftBic": "ifsc/Swift/Bic (Código curto do Reino Unido)",
	"bnk_Save": "Salvar",
	"db_requestBon": "Solicitar Bônus",
	"db_removeBon": "Remover bônus",
	"db_bonusList": "Lista de Bônus",
	"bver_bonusVerMsz1": "Seu pedido de bônus foi processado com sucesso.",
	"bver_backBonusList": "Voltar à lista de bônus",
	"bver_reqFailed": "Falha na solicitação",
	"bl_bonusList": "Lista de Bônus",
	"bl_created": "Data",
	"bl_amount": "Quantidade",
	"bl_bonusType": "Tipo de bônus",
	"bl_status": "Status",
	"bl_comments": "Comentários",
	"bl_complete": "Completo",
	"bl_pending": "Pendente",
	"rb_removeBonus": "Remover bônus",
	"rb_removebonusMsz1": "Desculpe, você não é elegível para remover o bônus.",
	"rb_availbonus": "Bônus disponível",
	"rb_bonusremove": "Insira o valor do bônus para remover",
	"rb_submit": "Submeter",
	"rb_googleAuth1": "Por favor, digite o Pin Único de 6 dígitos mostrado no",
	"rb_googleAuth2": "Autenticador do Google",
	"rb_googleAuth3": "aplicativo",
	"rb_validate": "Validar",
	"rb_googleAuth4": "Está tendo problemas com seu código de autenticação de dois fatores?",
	"rb_googleAuth5": "Clique aqui para verificar com e-mail",
	"rb_googleAuth6": "Enviamos um link para o seu e-mail",
	"rb_bonusGoogleAuth": "Por favor, clique no link para prosseguir com o seu levantamento",
	"rb_googleAuth7": "Não recebeu um e-mail em sua caixa de entrada ou pasta de spam? Reenviar",
	"rb_googleAuth8": "A autenticação de dois fatores não está habilitada na sua conta.",
	"rb_googleAuth9": "A autenticação de dois fatores adiciona uma camada extra de segurança, garantindo que é realmente você quem está tentando fazer alterações em sua conta fxview.",
	"rb_googleAuth10": "Clique aqui para ativar a autenticação do Google",
	"rb_congo": "Parabéns",
	"rb_removeBonusCongoMsz": "O bônus foi removido com sucesso paraTrading Id",
	"rb_goToDash": "Ir para o painel",
	"rb_noTradingAccFound": "Nenhuma conta de negociação ao vivo encontrada!",
	"rb_plzWaitWhileProc": "Por favor, aguarde enquanto estamos processando seus dados...",
	"rb_bonusGooglerequest": "Por favor, clique no link para prosseguir com o seu pedido de bónus",
	"rb_bonusGoogleremove": "Por favor, clique no link para prosseguir",
	"req_bonus": "Bônus",
	"req_bonusMsz1": "Desculpe você não ser elegível. Financie sua conta para aproveitar o bônus.",
	"req_allowMaxBonus": "Bônus máximo permitido",
	"req_amount": "Quantidade",
	"req_agreeTerms": "Concordo com os termos e condições",
	"reg_Agreee": "Concordo com o",
	"reg_TERMS": "termos e condições",
	"req_fieldReq": "Campo é obrigatório",
	"req_maxlev": "Alavancagem máxima permitida para aproveitar 100% de bônus de depósito é 300X. ",
	"req_tochangeleverage": "para mudar sua alavancagem",
	"req_bonusMsz2": "O bônus foi adicionado com sucesso para o Trading ID",
	"req_availBonus": "Use Bônus",
	"req_allowBonus": "Bônus permitido",
	"req_goBackMangeAcc": "Ir para Gerenciar conta",
	"req_noTradingAccFound": "Nenhuma conta de negociação ao vivo encontrada!",
	"req_minBonus": "bônus de depósito mínimo é de 200 dólares e estamos recebendo opção de depósito é",
	"req_maxAmount": "O valor máximo que você pode solicitar para bônus é ",
	"rb_ReadPolicy": "Leia nossa Política de Bônus",
	"dep_acc_fund_depFundAcc": "Depositar fundos em conta",
	"dep_acc_fund_tradAccId": "ID da Conta de Negociação",
	"dep_acc_fund_depFund": "Fundos de depósito",
	"dep_acc_fund_selDepMet": "Selecione o método de depósito",
	"dep_acc_fund_depFieldReq": "O campo DepositMethod é obrigatório",
	"dep_selectbankaccount": "Por favor, selecione a conta bancária",
	"dep_acc_fund_lessDet": "Menos detalhes",
	"dep_acc_fund_viewDet": "Ver Detalhe",
	"dep_holderName": "Nome do Titular",
	"dep_sortCode": "Código de classificação",
	"dep_reference": "Referência",
	"dep_fortradaccount": "Para conta de negociação",
	"dep_selectAcc": "Por favor, selecione a conta",
	"dep_acc_fund_DontbankAcc": "você não tem conta bancária, por favor",
	"dep_acc_fund_clkHere": "Clique Aqui",
	"dep_Createbank": "criar um novo banco",
	"dep_acc_fund_MinDepAmt": "Valor mínimo de depósito",
	"dep_acc_fund_SpeDepAm": "Especifique o montante do depósito",
	"dep_mindepositallow": "Depósito mínimo permitido",
	"dep_acc_fund_bakStp": "Etapa anterior",
	"dep_acc_fund_procToPay": "Proceder ao pagamento",
	"dep_ticketHasbeenCreated": "Seu ingresso foi criado",
	"dep_proMsz19": "Ir para Ingressos",
	"dep_acc_fund_PlsEnsCort": "Por favor, certifique-se de que os detalhes estão corretos",
	"dep_acc_fund_accountId": "ID da conta/número da carteira",
	"dep_acc_fund_feeUsd": "Taxa (USD)",
	"dep_acc_fund_depAmt": "Valor do depósito",
	"dep_acc_fund_depMeth": "Método de Depósito",
	"dep_acc_fund_noTrdAccFnd": "Nenhuma conta de negociação ao vivo encontrada!",
	"dep_acc_fund_plzWaitWhileProc": "Por favor, aguarde enquanto estamos processando seus dados...",
	"dep_maxlimit": "você aumentou o limite máximo de transação por mês",
	"dep_maxdeposit": "você pode depositar valor máximo = ",
	"dep_pleaseDeposit": "Quero depositar",
	"dep_pleaseDeposit1": "a partir de detalhes bancários mencionados abaixo <br>",
	"dep_AccNumber": "Número da conta",
	"dep_holdername": "Nome do Titular <br>",
	"dep_bankname": "Nome do Banco <br>",
	"dep_brsortCode": "Código de classificação <br>",
	"dep_brbankAdress": "Endereço do Banco <br>",
	"dep_depositDone": "depósito feito com sucesso",
	"dep_depositFail": "falha no depósito",
	"dl_depositList": "Lista de Depósitos",
	"dl_transId": "ID da Transação",
	"dl_status": "Status",
	"dl_Method": "Método",
	"dl_type": "Tipo",
	"dl_created": "Data",
	"dl_action": "Ação",
	"dt_depTransHist": "Histórico de transações de depósito",
	"dt_payMeth": "Forma de Pagamento",
	"dt_clickToResolve": "clique para resolver",
	"dw_acc_fund_selDepMet": "Selecione o método de depósito",
	"dw_acc_fund_depFieldReq": "O campo DepositMethod é obrigatório",
	"dw_selectaccount": "Por favor, selecione a conta bancária",
	"dw_acc_fund_lessDet": "Menos detalhes",
	"dw_acc_fund_viewDet": "Ver Detalhe",
	"dw_holderName": "Nome do Titular",
	"dw_bankName": "Nome do banco",
	"dw_bankAdd": "Endereço do banco",
	"dw_sortCode": "Código de classificação",
	"dw_reference": "Referência",
	"dw_fortradingAcc": "Para conta de negociação",
	"dw_acc_fund_DontbankAcc": "você não tem conta bancária, por favor",
	"dw_Createbank": "criar um novo banco",
	"dw_acc_fund_MinDepAmt": "Valor mínimo de depósito",
	"dw_acc_fund_SpeDepAm": "Especifique o montante do depósito",
	"dw_acc_fund_PlsEnsCort": "Por favor, certifique-se de que os detalhes estão corretos",
	"dw_acc_fund_accountId": "ID da conta",
	"dw_acc_fund_feeUsd": "Taxa (USD)",
	"dw_acc_fund_depAmt": "Valor do depósito",
	"dw_acc_fund_depMeth": "Método de Depósito",
	"dw_proMsz19": "Ir para Ingressos",
	"dw_acc_fund_plzWaitWhileProc": "Por favor, aguarde enquanto estamos processando seus dados...",
	"dw_bankCode": "Código do Banco <br>",
	"acc_reqProcessing": "processamento de pedidos...",
	"acc_accountVerMsz1": "o pedido foi processado com êxito",
	"acc_backAccountList": "Voltar à lista de contas",
	"acc_reqFailed": "Falha na solicitação",
	"acclist_myAccounts": "Minhas contas",
	"acclist_liveAccount": "Contas Reais",
	"acclist_demoAccount": "Contas Demo",
	"lev_changeLeverage": "Alavancagem de Mudança",
	"lev_exsistLev": "Alavancagem existente",
	"lev_newLev": "Nova alavancagem",
	"lev_backManageAccount": "Voltar para gerenciar conta",
	"lev_levMsz1": "Por favor, clique no link para alterar sua alavancagem.",
	"lev_levMsz2": "A alavancagem da sua conta de negociação foi alterada com sucesso",
	"lev_tradingId": "Ideias de Negociação",
	"lev_oldLev": "Alavancagem antiga",
	"lev_goBackMangeAccv": "Ir para Gerenciar conta",
	"lev_noDemoLiveTradingAccFound": "Nenhuma conta de negociação encontrada!",
	"lev_waitforVerf": "Por favor, aguarde a verificação.",
	"levPwd_passMsz1": "Por favor, clique no link para alterar sua senha",
	"lePwd_passMsz2": "A senha da sua conta de negociação foi alterada com sucesso",
	"lePwd_oldPassword": "Senha antiga",
	"Dlist_demoLive": "Demo/Live",
	"Dlist_accountType": "Tipo de conta",
	"Dlist_leverage": "Alavancagem",
	"detch_detachaccount": "Desanexar conta",
	"detch_fourfive": "454579",
	"detch_pamMaster": "Mestre Pamm",
	"detch_todd": "Todd Anderson",
	"detch_balance": "Equilíbrio",
	"detch_equity": "Equidade",
	"detch_freeMargin": "Margem Livre",
	"detch_MarginUSed": "Margem utilizada",
	"detch_pnl": "PnL",
	"detch_two": "$2000",
	"detch_eight": "$800",
	"detch_twelve": "$1200",
	"detch_three": "$300",
	"detch_twofive": "$-250",
	"detch_takenote": "Por favor, tome nota dos pontos abaixo",
	"detch_openPosition": "Todas as posições abertas serão fechadas antes do desligamento da conta.",
	"detch_finalPnl": "O PnL final pode variar de acordo com as condições de mercado.",
	"detch_afterOpen": "Após o fechamento das posições abertas, a Administração, o Custo de Subscrição, a Taxa de Desempenho serão calculados e deduzidos da conta, se houver.",
	"detch_terms": "Aceito os termos e condições acima",
	"detch_confirm": "Confirme",
	"It_oneRecord": "Você só tem um disco. Por favor, crie pelo menos mais uma conta de negociação ou carteira antes de tentar uma transferência interna",
	"It_liveAcc": "Conta Ativa",
	"It_wallet": "Carteira",
	"It_internalTransfer": "Transferência interna",
	"It_confToTransfer": "Por favor, confirme para continuar",
	"It_back": "Voltar",
	"It_freeMargin": "Margem Livre",
	"It_interTransSorryMsz": "Desculpe, você não tem saldo para transferir o valor para outra conta de negociação.",
	"It_transToAcc": "Transferir para ID da conta",
	"It_fieldReq": "Campo é obrigatório",
	"It_currentBalance": "Saldo Corrente",
	"It_pleseEnterAmount": "por favor, insira o valor",
	"It_submit": "Submeter",
	"It_intTransMsz2": "Por favor, clique no link para confirmar sua transferência interna",
	"It_intTransMsz3": "A transferência foi concluída com êxito",
	"It_fromTradId": "Do Trading ID",
	"It_towallet": "Para Carteira",
	"It_toTradId": "Para Trading ID",
	"It_transferAmount": "montante transferido",
	"It_backinternalTrans": "Voltar à transferência interna",
	"It_interTransDeducted": "será deduzido do seu",
	"It_depostotradAcc": "será depositado no seu",
	"Itwallet_backwallet": "De volta à carteira",
	"Itwallet_cancel": "Cancelar",
	"Itwallet_fromwal": "da carteira",
	"Itwallet_towal": "Para Carteira",
	"Itwallet_backtowallet": "De volta à carteira",
	"sub_SubliveAcc": "Subscrever Conta Real",
	"sub_subscribe": "Subscrever",
	"sub_backtradingTool": "Voltar à caixa de ferramentas de negociação",
	"sub_enterotp": "Digite Otp",
	"sub_validate": "Validar",
	"sub_resendOtp": "Reenviar Otp",
	"sub_congo": "Parabéns",
	"sub_tradingId": "ID de negociação",
	"sub_addtradertool": "Por favor, adicione Add Trader Tool Box por seguintes detalhes <br> account_id",
	"re_marketinsight": "Insights de Mercado",
	"re_news": "Notícias",
	"edu_learnTrade": "Aprenda a Negociar",
	"edu_offerEdu": "Oferecemos recursos educacionais para aprender tudo sobre negociação. Nossos materiais de aprendizagem atendem a todos os níveis de conhecimento e permitem que você melhore sua compreensão dos mercados globais, negociação on-line e nossas ferramentas de negociação. Nossa lista abrangente de tópicos de negociação varia de básico a avançado, e irá ajudá-lo a elevar sua negociação a um nível mais alto.",
	"edu_Enhance": "Melhore sua compreensão dos mercados globais e leve sua negociação para o próximo nível, aproveitando nossos recursos educacionais. A educação da Fxview oferece uma extensa lista de tópicos que atendem a todos os níveis de traders - de iniciantes a avançados - e abrange tanto como os mercados funcionam, bem como como usar nossas ferramentas de negociação a seu favor.",
	"edu_tradeconfidence": "Você aprenderá a negociar com confiança, concentrando-se nos aspectos técnicos e fundamentais da negociação/investimento com nossa ajuda e suporte durante todo o processo",
	"edu_basic": "Básico",
	"edu_advance": "Avançado",
	"edu_general": "Geral",
	"edu_forex": "Forex",
	"edu_commodities": "Commodities",
	"edu_indices": "índices",
	"edu_stocks": "Estoques",
	"edu_thereIsNoRecord": "Nenhum registro encontrado",
	"marin_source": "Fonte",
	"marin_loadmore": "Carregue mais",
	"marin_loadwait": "Carregando por favor aguarde...",
	"news_marketnews": "Notícias do Mercado",
	"news_fearurednews": "Notícias em destaque",
	"news_market": "Mercado",
	"news_nodata": "Sem dados",
	"news_latestnews": "Últimas Notícias",
	"video_video": "Vídeo",
	"video_tut": "Tutoriais",
	"video_intrestedforex": "Interessado em negociação forex? Você está no lugar certo. Fxview oferece uma série de tutoriais em vídeo para ajudá-lo a desenvolver suas habilidades e aprender a negociar como os profissionais. Nossos guias passo a passo incluem instruções sobre registro, verificação de conta, terminologia forex básica, funcionalidade da plataforma de negociação e muito mais.",
	"video_allvideo": "Todos os vídeos",
	"video_fxviewtut": "Tutoriais Fxview",
	"video_platTut": "Tutoriais da Plataforma",
	"video_forexBasic": "Noções básicas de Forex",
	"video_whatisforex": "O que é o forex",
	"web_webinars": "Webinars",
	"web_enhancetrad": "Melhore sua negociação inscrevendo-se em nossos webinars gratuitos e aprendendo com especialistas. Nossos webinars são projetados especificamente para aumentar seu conhecimento de mercado e aprimorar suas habilidades de negociação. Os especialistas revelam as principais estratégias e conceitos de negociação, que podem beneficiar tanto os iniciantes quanto os experientes.",
	"web_registeran": "Registe-se para um",
	"web_upcomingweb": "próximo webinar",
	"web_register": "Cadastre-se",
	"web_timeleft": "Tempo Resta",
	"web_days": "DIAS",
	"web_hours": "HORAS",
	"web_mins": "ATAS",
	"web_secs": "SECS",
	"web_webnar": "Webinar",
	"web_library": "biblioteca",
	"web_higherpower": "Trendlines-Webinar",
	"web_aprtwenty": "(9 de agosto de 2021)",
	"web_findright": "Apoio e Resistência-Webinar",
	"web_aprsixteen": "(11 de agosto de 2021)",
	"web_weekahead": "Indicadores Básicos-Webinar",
	"web_aprtwelve": "(13 de agosto de 2021)",
	"web_introTrend": "Introdução aos Indicadores de Tendência - Webinar",
	"web_apreighteen": "18 de março",
	"web_topicdiscuss": "TEMA DE DISCUSSÃO",
	"web_correlation": "FXVIEW-Usando correlação para melhorar sua negociação",
	"web_datemay": "May 11, 2021 12",
	"web_showlocal": "Mostrar a minha hora local",
	"web_joinfxview": "Junte-se ao especialista da Fxview, pois ele lhe dá insights sobre o uso da correlação para melhorar suas habilidades de negociação.",
	"web_secureplace": "Garanta seu lugar com um especialista do setor e aprenda o que é preciso para ser um trader profissional de Forex",
	"web_topicsCovered": "TÓPICOS A SEREM ABORDADOS DURANTE O WEBINAR",
	"web_strongweak": "- Correlação forte vs fraca",
	"web_corrmultiple": "- Correlação entre vários períodos de tempo",
	"web_posneg": "- Compreender a correlação positiva e negativa",
	"ForexGlossarySpan": "Forex <span>Glossário</span>",
	"ForexGlossaryGuide": "O glossário forex da Fxview é um guia completo para ajudá-lo a aprender a terminologia forex básica e se familiarizar com a linguagem do trader.",
	"AGGREGATE_DEMAND": "DEMANDA AGREGADA",
	"text": "É uma medida econômica da demanda total por todos os bens e serviços acabados em uma economia/setor. Indica como os níveis de preços atuais se relacionam com o PIB (Produto Interno Bruto) real de uma nação.",
	"APPRECIATION": "APRECIAÇÃO",
	"AppText": "Refere-se a um aumento do valor de uma moeda em relação a outra moeda em resposta à demanda do mercado.",
	"ARBITRAGE": "ARBITRAGEM",
	"ArbText": "A compra de um ativo financeiro em um mercado e a venda simultânea em outro mercado para se beneficiar dos diferenciais de preço é conhecida como arbitragem.",
	"AROUND": "AO REDOR",
	"ArndText": "Jargão do dealer usado na cotação quando o prêmio/desconto a termo está próximo da paridade. Por exemplo, `dois-dois ao redor` se traduziria em 2 pontos para cada lado do ponto atual.",
	"ASK_RATE": "TAXA ASK",
	"Asktext": "A taxa/preço a que um instrumento financeiro é colocado à venda.",
	"ASSET_ALLOCATION": "ALOCAÇÃO DE ATIVOS",
	"AsstText": "Uma estratégia de investimento que visa equilibrar risco e recompensa, alocando fundos em diferentes ações, títulos, commodities, moedas e outras classes de ativos de acordo com os objetivos dos investidores.",
	"Back_office": "Backoffice",
	"BalanceofTrade": "Balança Comercial",
	"BarCharts": "Gráficos de Barras",
	"BaseCurrency": "Moeda Base",
	"BearMarket": "Mercado em baixa",
	"BidRate": "Taxa de licitação",
	"btext1": "Os departamentos verificam todos os processos de liquidação e relacionados",
	"btext2": "A diferença de valor entre as exportações e as importações de um país.",
	"btext3": "Os gráficos de barras são usados nos mercados financeiros para transmitir os movimentos de preços em um gráfico de fácil leitura. Eles são basicamente um gráfico OHLC usado para gráficos de preços. Há um tick no gráfico que fornece o preço em um determinado período de tempo em abertura, alta, baixa e fechamento.",
	"btext4": "Uma moeda que aparece em uma cotação de par forex. Há sempre uma moeda no mercado forex que é sempre cotada em relação a outra, pois você está comprando uma enquanto vende a outra. A moeda base aparecerá primeiro, seguida pela segunda moeda (cotação). Por exemplo, se você estiver olhando para o par EUR/USD, aqui a moeda base é o Euro e a moeda de cotação é o dólar americano.",
	"btext5": "Um mercado caracterizado pela queda dos preços.",
	"btext6": "O preço máximo que um comprador está disposto a pagar.",
	"CABLE": "CABO",
	"CABLEText": "Um apelido usado para o par GBP/USD. O termo originou-se devido ao fato de que a taxa foi originalmente transmitida através de um cabo transatlântico a partir de meados de 1800, quando a GBP era a moeda do comércio internacional.",
	"CANDLESTICK_CHART": "GRÁFICO DE VELAS",
	"CANDLESTICK_CHARTText": "Também chamado de gráfico de velas japonês, é um tipo de gráfico de barras usado essencialmente para descrever os movimentos de preço de um título, derivativo ou moeda. Cada `candlestick` normalmente mostra um dia e representa a diferença entre o preço de abertura e fechamento. Se o preço de abertura for maior que o preço de fechamento, a vela/retângulo será sombreado. Se o preço de fechamento for maior que o preço de abertura, essa área do gráfico não será sombreada.",
	"CENTRAL_BANK": "BANCO CENTRAL",
	"CENTRAL_BANKText": "Um governo ou organização quase governamental que supervisiona as políticas monetárias de um país e imprime moedas. Por exemplo – a Reserva do Banco Federal (EUA), o Banco Central Europeu (Europa), o Banco da Reserva da Austrália (Austrália).",
	"CHARTISTs": "CARTISTA",
	"CHARTISTsText": "Um indivíduo (também conhecido como trader técnico) que usa tabelas e gráficos para interpretar dados históricos, a fim de encontrar tendências e prever movimentos futuros de preços.",
	"CHOICE_MARKET": "MERCADO DE ESCOLHA",
	"CHOICE_MARKETText": "Também chamado de mercado fechado, é um mercado sem spread. Significa que uma moeda pode ser comprada ao mesmo preço que pode ser vendida no mercado",
	"CLEARING": "LIMPEZA",
	"CLEARINGtext": "Processo de conciliação ou liquidação de compras e vendas de diversos instrumentos financeiros.",
	"CONTAGION": "CONTÁGIO",
	"CONTAGIONText": "Tendência de uma crise econômica se espalhar de um mercado para outro.",
	"COLLATERAL": "CAUÇÃO",
	"COLLATERALText": "Algo dado por um mutuário para garantir um empréstimo ou como garantia de desempenho.",
	"COMMISSIONs": "COMISSÃO",
	"COMMISSIONText": "Uma taxa de transação cobrada pela corretora dos comerciantes/investidores. ",
	"CONFIRMATION": "CONFIRMAÇÃO",
	"CONFIRMATIONText": "Documentos trocados por contrapartes de uma transação que estabeleça os termos da referida transação.",
	"CONTRACTunit": "CONTRATO (unidade ou lote)",
	"CONTRACTunitText": "A unidade padrão de negociação.",
	"COUNTERPARTY": "CONTRAPARTE",
	"COUNTERPARTYText": "Um dos participantes, seja um banco ou cliente, com quem é feita uma transação financeira.",
	"COUNTRY_RISK": "RISCO PAÍS",
	"COUNTRY_RISKText": "Riscos associados a transações transfronteiriças, tais como condições legais e políticas como a guerra.",
	"CROSS_RATES": "TAXAS CRUZADAS",
	"CROSS_RATESText": "Taxas de câmbio entre duas moedas que não envolvem o dólar. Diz-se que uma taxa cruzada não é padrão no país onde o par de moedas é cotado.",
	"CURRENCYe": "MOEDA",
	"CURRENCYText": "Um meio de troca na forma de papel, metal ou digital emitido por um governo/banco central e usado como curso legal. ",
	"CURRENCY_RISK": "RISCO CAMBIAL",
	"CURRENCY_RISKText": "Risco de incorrer em perdas devido a uma variação adversa das taxas de câmbio.",
	"Day_trading": "Day trading",
	"Day_tradingText": "Uma estratégia de negociação envolvendo abertura e fechamento de posições dentro do mesmo dia.",
	"Dealer": "Revendedor",
	"DealerText": "Uma pessoa que atua como mandante ou contraparte de uma transação. Principal basicamente está de um lado na esperança de obter um bom lucro fechando a posição em uma negociação subsequente com outra parte.",
	"Deficit": "Déficit",
	"DeficitText": "Montante pelo qual o custo das importações de um país excede o custo das suas exportações ou também é chamado de balança comercial negativa.",
	"Delivery": "Entrega",
	"DeliveryText": "A liquidação de uma transação por entrega de fundos. OU A data de vencimento de um contrato, quando a liquidação final de uma transação é feita por troca das moedas.",
	"Depreciation": "Depreciação",
	"DepreciationText": "Declínio do valor de uma moeda em relação a outra moeda devido a condições de mercado ou outros fatores.",
	"Derivative": "Derivada",
	"DerivativeText": "Os derivativos derivam seu valor do preço de um ativo subjacente e muitas vezes usados pelos traders como um instrumento para especular sobre os movimentos futuros de preço de um ativo sem ter que comprar o próprio ativo. Opção é o instrumento derivativo mais comum.",
	"Devaluation": "Desvalorização",
	"DevaluationText": "Uma moeda desvaloriza-se quando o seu valor diminui em relação a uma ou mais outras moedas.",
	"ECONOMIC_INDICATOR": "INDICADOR ECONÓMICO",
	"ECONOMIC_INDICATORText": "Uma medida estatística emitida pelo governo ou uma instituição não governamental que indica a condição econômica de uma economia como PIB, investimento estrangeiro, déficits comerciais, taxas de emprego, etc.",
	"ENDOFDAYORDER": "ORDEM DE FIM DE DIA",
	"ENDOFDAYORDERText": "Uma ordem de compra ou venda a um preço especificado que só está aberta até o final do dia de negociação, normalmente 17h/17",
	"EUROs": "EURO",
	"EUROsText": "Moeda da União Monetária Europeia (UEM).",
	"EUROPEANCENTRALBANK": "BANCO CENTRAL EUROPEU",
	"EUROPEANCENTRALBANKText": "Criado em 1998, é o Banco Central da União Monetária Europeia (UEM).",
	"FederalDepositInsurance": "Federal Deposit Insurance Corporation (FDIC)",
	"FederalDepositInsuranceText": "Uma agência federal independente que protege os consumidores e o sistema financeiro dos EUA. O FDIC é o mais conhecido para o seguro de depósitos, pois ajuda os clientes a evitar perdas em caso de falências bancárias",
	"FederalReserveSystem": "Sistema de Reserva Federal",
	"FederalReserveSystemText": "A instituição financeira mais poderosa do mundo. O Sistema de Reserva Federal foi fundado pelo Congresso dos EUA em 1913 com o objetivo de fornecer um sistema monetário estável e compreende uma agência do governo central e 12 bancos regionais de reserva federal.",
	"FixedExchangeRate": "Taxa de Câmbio Fixa",
	"FixedExchangeRateText": "Um regime de taxas de câmbio em que o valor de uma moeda é fixado por uma autoridade monetária em relação ao valor de uma ou mais moedas.",
	"FloatingExchangeRate": "Taxa de Câmbio Flutuante",
	"FloatingExchangeRateText": "Um regime de taxa de câmbio em que o valor da moeda é fixado pelo mercado forex com base na demanda e na oferta em relação a outras moedas.",
	"Flatsquare": "Plano/quadrado",
	"FlatsquareText": "O jargão do dealer costumava descrever uma posição que foi completamente invertida. Por exemplo, você comprou US$ 100.000 e depois vendeu US$ 100.000, criando uma posição plana.",
	"Foreign_Exchange": "Câmbio",
	"Foreign_ExchangeText": "Câmbio é a troca de uma moeda pela outra. É a rede on-line global onde os comerciantes compram e vendem moedas. Não tem localização física e funcionava 24 horas por dia",
	"Forward": "Avante",
	"ForwardText": "Taxa pré-especificada para travar um preço em um momento futuro específico, com base no diferencial de taxa de juros entre as duas moedas envolvidas.",
	"Forward_Contracts": "Contratos a termo",
	"Forward_ContractsText": "Um acordo entre as duas partes para comprar ou vender um ativo a uma taxa especificada em uma data de vencimento pré-especificada. Ambas as partes são obrigadas a cumprir o fim do acordo.",
	"ForwardRates": "Taxas a prazo (swaps)",
	"ForwardRatesText": "Taxa a termo é um preço à vista de 2 moedas de diferença de juros para um período fixo e pode ser facilmente calculado desde que as taxas de juros fixas de cada moeda e a taxa à vista atual sejam dadas.",
	"Forward_Trading": "Negociação a termo",
	"Forward_TradingText": "Forward Trading está fazendo a negociação oposta de uma negociação à vista em determinado momento. Os traders geralmente trocam suas negociações para frente variando de uma semana a meses. Mesmo que o contrato a termo ocorra em uma data futura, ainda assim a posição pode ser fechada a qualquer momento. Em seguida, essa parte de fechamento da posição é trocada para a frente para a mesma data de valor futuro.",
	"Forwardpoints": "Pontos para a frente",
	"ForwardpointsText": "Simplesmente os pips que são adicionados ou subtraídos da taxa de câmbio atual para calcular um preço a termo.",
	"Fundamental_Analysis": "Análise Fundamentalista",
	"Fundamental_AnalysisText": "Método de analisar os fatores que podem influenciar o preço no futuro. Esta forma de análise é baseada em eventos e influências externas, bem como tendências da indústria, onde como comerciantes técnicos derivam informações de gráficos e padrões.",
	"FuturesContract": "Contrato Futuro",
	"FuturesContractText": "Um acordo legal entre duas partes para negociar a um preço pré-determinado, em uma data pré-determinada no futuro. Os futuros são negociados em bolsa e podem ser usados para ganhar exposição a uma ampla gama de ativos.",
	"Gearing": "Engrenagem",
	"GearingText": "Quando um comerciante está negociando com uma dívida parcial ou margem.",
	"GroupofFive": "Grupo dos Cinco (G5)",
	"GroupofFiveText": "Cinco nações industriais líderes - França, Japão, Reino Unido, Alemanha e EUA que se reúnem de tempos em tempos com o motivo de discutir problemas econômicos comuns.",
	"GroupofSeven": "Grupo dos Sete (7)",
	"GroupofSevenText": "O Grupo dos Sete são 7 países industrializados não comunistas líderes compostos por França, Alemanha, Reino Unido, Alemanha e EUA, além de Canadá e Itália. Eles agora são conhecidos como o G8 desde a adição da Rússia.",
	"GroupofTen": "Grupo dos Dez (G10)",
	"GroupofTenText": "Também chamado de O Clube de Paris composto por Canadá, Bélgica, França, Alemanha, Itália, Suécia, Japão, Reino Unido, EUA e Holanda. Foi criado em 1962 para disponibilizar os fundos ao FMI e ajudar os países membros com dificuldades de balanço de pagamentos",
	"GoldilocksEconomy": "Economia Cachinhos Dourados",
	"GoldilocksEconomyText": "Um termo que é usado para descrever uma economia que não é muito quente ou muito fria e sustenta um crescimento moderado com taxa nominal de inflação, que permite uma política monetária amigável ao mercado.",
	"GoodtilCancel": "Bom até Cancelado (GTC)",
	"GoodtilCancelText": "Uma encomenda que é válida até ser cancelada ou concluída, independentemente do período de tempo em que a encomenda foi feita.",
	"HEDGING": "COBERTURA",
	"HEDGINGText": "Uma estratégia de gestão de risco em que os investidores 'hedge' para se protegerem de movimentos adversos de preços, assumindo duas posições opostas e, assim, reduzir o risco. No contexto das transações cambiais, protegeria contra flutuações na taxa de câmbio cambial. ",
	"INFLATION": "INFLAÇÃO",
	"INFLATIONText": "Um aumento contínuo do nível geral de preços dos bens de consumo, o que corrói o poder de compra.",
	"INITIALMARGIN": "MARGEM INICIAL",
	"INITIALMARGINText": "O depósito inicial de garantia necessário para entrar em uma posição como garantia sobre o desempenho futuro.",
	"INTERBANKRATES": "TAXAS INTERBANCÁRIAS",
	"INTERBANKRATESText": "As taxas de câmbio a que os grandes bancos internacionais cotam outros grandes bancos internacionais.",
	"LEADINGINDICATORS": "PRINCIPAIS INDICADORES",
	"LEADINGINDICATORSText": "Variáveis econômicas consideradas para prever a atividade econômica futura.",
	"LEVERAGEs": "ALAVANCAGEM",
	"LEVERAGEsText": "A alavancagem é oferecida pelas corretoras para maximizar o poder de compra do trader. Ele pode ser descrito como `capital emprestado` do ponto de vista dos traders e aumenta seus retornos potenciais, uma vez que você pode negociar volumes muito maiores com esses fundos do que seu capital limitado. É expresso em razões como 1",
	"LIBOR": "LIBOR",
	"LIBORText": "O Interbank de Londres ofereceu Rate. É a taxa de juro de referência a que os grandes bancos mundiais emprestam uns aos outros",
	"LIMITORDER": "ORDEM LIMITE",
	"LIMITORDERText": "Uma ordem para executar uma negociação a um preço especificado ou melhor. Por exemplo, se o preço atual de EUR/USD é 1.08502/1.08522, então uma ordem limite para comprar EUR seria a um preço abaixo do preço de mercado,1.0820.",
	"LINECHARTS": "GRÁFICOS DE LINHAS",
	"LINECHARTSText": "Um gráfico de preços conectando preços únicos (todos os preços de fechamento) para um período de tempo selecionado. ",
	"LIQUIDITYs": "LIQUIDEZ",
	"LIQUIDITYsText": "A capacidade de um par de moedas de ser comprado e vendido no mercado sem causar uma mudança significativa em sua taxa de câmbio.",
	"LIQUIDATION": "LIQUIDAÇÃO",
	"LIQUIDATIONText": "Fechamento de uma posição existente através da execução de uma operação de compensação.",
	"LONGPOSITION": "POSIÇÃO LONGA",
	"LONGPOSITIONText": "Diz-se que uma posição é 'longa' se se valoriza quando os preços de mercado aumentam. Quando alguém compra um par de moedas, sua posição é longa nesse par.",
	"Margins": "Margem",
	"MarginText": "Margem é a quantidade de dinheiro necessária para manter uma posição de margem aberta. É a diferença entre o valor total da sua posição e os fundos que estão sendo emprestados a você por uma corretora/alavancagem.",
	"MarginDeposit": "Depósito de Margem",
	"MarginDepositText": "Um depósito de margem é a quantidade inicial de dinheiro que um trader precisa colocar para baixo para abrir uma posição de negociação alavancada. Também pode ser conhecido como margem inicial, depósito ou simplesmente depósito.",
	"MarginCall": "Chamada de margem",
	"MarginCallText": "Uma chamada de margem pode ser descrita como um alerta/solicitação/chamada de seu corretor para notificá-lo de que sua margem de manutenção caiu abaixo do mínimo e sua posição corre o risco de ser liquidada. Então, nesse caso, uma corretora pede a um cliente que carregue sua conta para manter a posição existente aberta.",
	"MarketMaker": "Formador de Mercado",
	"MarketMakerText": "Um concessionário que mantém um preço firme de compra e venda e está pronto para fazer mercado de dois lados para qualquer instrumento financeiro.",
	"MarketRisk": "Risco de Mercado",
	"MarketRiskText": "Exposição a variações de preços de mercado.",
	"Marktomarket": "Marcar para o mercado",
	"MarktomarketText": "Ajustar/Avaliar todas as posições em aberto de acordo com os preços correntes de mercado.",
	"Maturity": "Maturidade",
	"MaturityText": "A data de liquidação ou de caducidade de um instrumento financeiro.",
	"NarrowMarket": "Mercado estreito",
	"NarrowMarketText": "Mercado de câmbio também caracterizado por Thin Market onde há um baixo número de compradores e vendedores e os preços tendem a ser voláteis.",
	"Offer_s": "Oferta",
	"OfferText": "O mesmo que o preço de venda, o preço pelo qual um revendedor está disposto a vender.",
	"Offsettingtransaction": "Operação de compensação",
	"OffsettingtransactionText": "Compensação pode significar fechar uma posição para cancelar ou compensar parte ou todo o risco de mercado de uma posição aberta.",
	"OneCancelsOrder": "Um cancela o outro pedido (OCO)",
	"OneCancelsOrderText": "Quando você coloca uma ordem de parada e uma ordem de limite e se uma delas for executada, a outra ordem será automaticamente cancelada.",
	"Openorder": "Ordem aberta",
	"OpenorderText": "Uma ordem que não tem data de vencimento específica e executada quando um preço de mercado específico é atingido. Eles são geralmente associados a ordens GTC.",
	"Open_position": "Posição aberta",
	"OpenPositionText": "Uma posição que ainda está ativa e ainda não foi fechada ou revertida.",
	"OvertheCounter": "Balcão (OTC)",
	"OvertheCounterText": "A negociação OTC é para os valores mobiliários das empresas que não estão listadas em nenhuma bolsa central e, portanto, a compra e venda desses títulos é feita no balcão, ou seja, por meio de corretores e dealers privados, que negociam diretamente com compradores e vendedores.",
	"Overnight": "Da noite para o dia",
	"OvernightText": "Uma negociação/posição que permanece aberta até o próximo dia útil.",
	"Pip_s": "Pips",
	"PipText": "A menor quantidade de mudança em um preço forex cotado. A maioria das principais moedas define um pips como a quarta casa decimal, de modo que uma mudança de um pip é equivalente a 0,0001, exceto o iene japonês, onde um pip é o segundo dígito após o ponto decimal.",
	"PoliticalRisk": "Risco político",
	"PoliticalRiskText": "Devido a mudanças ou instabilidade na política governamental, efeito adverso sobre as posições/retornos de um investidor.",
	"PointFigureCharts": "Gráficos de ponto & Figura",
	"PointFigureChartsText": "O gráfico Point & Figure não leva em consideração o tempo e se concentra completamente nos movimentos de preços e tendências do ativo.",
	"Position_s": "Posição",
	"PositionText": "Posição é o termo financeiro para uma negociação que está atualmente ativa e capaz de incorrer em perda/ganho chamada posição aberta ou uma negociação que foi fechada recentemente conhecida como posição fechada.",
	"Premium": "Prêmio",
	"PremiumText": " O montante pelo qual o preço futuro ou a prazo excede o preço à vista.",
	"PriceTransparency": "PriceTransparency",
	"PriceTransparencyText": "Elucidar cotações às quais todos os participantes do mercado podem ter igual acesso",
	"Quote_s": "Citação",
	"QuoteText": "Um preço pelo qual um ativo foi negociado pela última vez ou pode ser atualmente comprado ou vendido e usado apenas para informações adicionais.",
	"RATE_s": "TAXA",
	"RATEText": "O preço de uma moeda em termos da outra, cujos valores mudam em relação a cada uma ao longo do tempo.",
	"RESISTANCE_s": "RESISTÊNCIA",
	"RESISTANCEText": "Um termo de análise técnica comumente usado que indica um nível de preço específico no qual uma moeda terá a incapacidade de cruzar. Esse preço funciona como um teto.",
	"REVALUATION": "REAVALIAÇÃO",
	"REVALUATIONText": "O oposto da desvalorização, a reavaliação é um ajuste para cima da taxa de câmbio oficial de um país como resultado da intervenção do banco central.",
	"REVALUATIONRATES": "TAXAS DE REAVALIAÇÃO",
	"REVALUATIONRATESText": "Essas são taxas de mercado usadas como valor base pelos traders para avaliar se o lucro/perda foi realizado no dia ou no geral. Normalmente, a taxa de reavaliação é a taxa de fechamento do dia de negociação anterior. ",
	"RISK_s": "RISCO",
	"RISKText": "Potencial de um resultado negativo, como desempenho abaixo do esperado, falha em atingir os objetivos de negociação/investimento ou perda de dinheiro ou mudanças adversas.",
	"RISKCAPITAL": "CAPITAL DE RISCO",
	"RISKCAPITALText": "A quantidade de dinheiro que um indivíduo é capaz de investir, cuja perda não resultará em uma mudança substancial em seu estilo de vida",
	"RISK_MANAGEMENT": "GESTÃO DE RISCOS",
	"RISKMANAGEMENTText": "Todas as técnicas e estratégias utilizadas para mitigar e/ou controlar os riscos inerentes à negociação e ao investimento, tais como o uso de stop loss, hedge, diversificação etc.",
	"ROLLOVER": "ROLAR",
	"ROLLOVERText": "É o fechamento simultâneo de uma posição aberta para a data de valor de hoje e a abertura da mesma posição para a data-valor do dia seguinte a um preço que reflete os diferenciais de taxa de juros entre duas moedas.",
	"ROLLOVERRATE": "TAXA DE ROLAGEM",
	"ROLLOVERRATEText": "Os juros pagos ou auferidos durante a noite para deter a(s) posição(ões), em função da margem e posição estabelecidas no mercado.",
	"SETTLEMENT": "LIQUIDAÇÃO",
	"SETTLEMENTText": "A transferência de propriedade de um instrumento financeiro para um comprador. A liquidação de transações cambiais pode ou não envolver a troca física efetiva de uma moeda para outra.",
	"SHORTPOSITION": "POSIÇÃO CURTA",
	"SHORTPOSITIONText": "Diz-se que uma posição é curta quando um trader vende um título primeiro com a intenção de recomprá-lo mais tarde, quando o preço cai. Tal posição é tomada quando ele acredita que os preços provavelmente cairão em um futuro próximo",
	"SLIPPAGE": "DERRAPAGEM",
	"SLIPPAGEText": "A derrapagem ocorre quando o spread bid/ask muda entre o momento em que uma ordem é solicitada até o momento em que a ordem é executada. Isso geralmente acontece durante períodos de alta volatilidade e ocorre em todos os mercados, como ações, títulos, moedas e futuros",
	"SPOTNEXT": "SPOT/NEXT",
	"SPOTNEXTText": "Também conhecido como `próximo dia útil`, denota a entrega de uma moeda comprada em um dia após a data à vista. São swaps de curto prazo em que uma moeda é lançada mais um dia, ou seja, após o spot. ",
	"SPOTPRICE": "PREÇO SPOT",
	"SPOTPRICEText": "O preço de mercado atual de um instrumento financeiro. ",
	"SPOTRATE": "SPOT (TAXA)",
	"SPOTRATEText": "A taxa de câmbio atual pela qual uma moeda pode ser comprada ou vendida. É a taxa cotada no mercado varejista sem ajuste pelo diferencial de juros. ",
	"SPOTTRADE": "COMÉRCIO SPOT",
	"SPOTTRADEText": "Refere-se à compra e venda de um produto financeiro para entrega instantânea em uma data específica à vista. Também conhecido como transação à vista e normalmente são liquidados eletronicamente. ",
	"Spread_s": "Espalhe",
	"SpreadText": "Um spread na negociação significa o intervalo/diferença entre o preço de compra e o preço de venda cotado para um par de moedas.",
	"Sterling": "Sterling",
	"SterlingText": "Um termo para a libra esterlina.",
	"StopLossOrder": "Ordem de Stop Loss",
	"StopLossOrderText": "Um tipo de ordem para vender uma moeda quando o preço atinge ou cai abaixo do preço especificado. Isso é usado para limitar a perda, geralmente quando o preço não pode ser monitorado ativamente pelo comerciante.",
	"StochasticOscillator": "Oscilador Estocástico",
	"StochasticOscillatorText": "O termo Estocástico refere-se ao ponto de um preço atual em relação à sua faixa de preço durante um período de tempo. O Oscilador Estocástico é um indicador de análise técnica popular que afirma que, durante um mercado de negociação ascendente, os preços tendem a fechar perto de sua alta e vice-versa.",
	"SupportLevels": "Níveis de Suporte",
	"SupportLevelsTexts": " Este termo indica um nível de preço específico no qual uma moeda terá a incapacidade de cruzar abaixo. O suporte ocorre quando os preços em queda param, mudam de direção e começam a subir. O nível de suporte é muitas vezes visto como um `piso` que está apoiando ou segurando os preços.",
	"Swap_s": "Troca",
	"SwapText": "Swap é um contrato de derivados através do qual duas partes trocam fluxos de caixa ou passivos decorrentes de dois instrumentos financeiros diferentes.",
	"Swift": "Rápido",
	"SwiftText": "Sociedade de Telecomunicações Financeiras Interbancárias Mundiais. Ele fornece uma rede de computadores dedicada que permite que instituições financeiras em todo o mundo apoiem mensagens de transferência de fundos em um ambiente seguro, padronizado e confiável.",
	"TECHNICALANALYSIS": "ANÁLISE TÉCNICA",
	"TECHNICALANALYSISText": "Envolve a utilização de diversos indicadores técnicos e análise da ação do mercado através do estudo de gráficos, volume, tendências, padrões, médias móveis e diversos outros indicadores técnicos com a finalidade de prever preços.",
	"TICK_s": "ASSINALAÇÃO",
	"TICKText": "Um tick representa qualquer cotação de preço futura, para cima ou para baixo. ",
	"TICKER": "TICKER",
	"TICKERText": "Ele mostra o histórico atual ou recente de uma moeda no formato de uma tabela ou um gráfico.",
	"TOMORROWNEXT": "AMANHÃ PRÓXIMO (TOM/NEXT)",
	"TOMORROWNEXTText": "É a compra e venda simultânea de uma moeda para entrega no dia seguinte.",
	"TRADING_s": "NEGOCIAÇÃO",
	"TRADINGText": "O ato de comprar, vender, trocar ações, títulos ou moedas, etc.",
	"TRANSACTIONCOST": "CUSTO DE TRANSAÇÃO",
	"TRANSACTIONCOSTText": "Custo de compra e venda de um instrumento financeiro.",
	"TRANSACTIONDATE": "DATA DA TRANSAÇÃO",
	"TRANSACTIONDATEText": "A data em que ocorre uma negociação.",
	"TREND_s": "TENDÊNCIA",
	"TRENDText": "Uma tendência é simplesmente a tendência de um preço se mover em uma determinada direção, para cima/para baixo/para trás/para os lados. Geralmente são divididos em três categorias – tendências principais, intermediárias e de curto prazo. ",
	"TRENDLINE": "LINHA DE TENDÊNCIA",
	"TRENDLINEText": "Este é um indicador técnico muito usado para descobrir tendências. Uma linha de tendência conecta duas ou mais baixas ou mais altas com as linhas projetadas para o futuro. Ele é calculado usando o método dos mínimos quadrados e também é chamado de regressão linear.",
	"TURNOVER": "VOLUME de NEGÓCIOS",
	"TURNOVERText": "É o valor monetário total de todas as transações executadas em um determinado período de tempo. ",
	"TWOWAYPRICE": "PREÇO DE MÃO DUPLA",
	"TWOWAYPRICEText": "Uma cotação bidirecional indica o preço de oferta atual e o preço de venda atual de um título em um dia de negociação.",
	"UPTICK": "UPTICK",
	"UPTICKText": "Um aumento ocorre quando o preço de um título sobe em relação ao último tick. É uma nova cotação a um preço superior à cotação anterior. ",
	"UPTICKRULE": "REGRA DE UPTICK",
	"UPTICKRULEText": "Uma restrição comercial nos EUA que afirma que a venda a descoberto só é permitida em um aumento. De acordo com a regra, um título não pode ser vendido a descoberto a menos que a última negociação anterior à venda a descoberto tenha sido a um preço inferior ao preço a que a venda a descoberto é executada.",
	"USPRIMERATE": "TAXA PRIME DOS EUA",
	"USPRIMERATEText": "A taxa de juros a que os bancos americanos emprestarão a seus principais clientes corporativos.",
	"VALUEDATE": "DATA DO VALOR",
	"VALUEDATEText": "A data em que as contrapartes concordam em liquidar suas respectivas obrigações. Para transações em moeda à vista, a data do valor geralmente é de dois dias úteis para frente. Também conhecida como data de vencimento, é a data em que a transação é liquidada. ",
	"VARIATIONMARGIN": "MARGEM DE VARIAÇÃO",
	"VARIATIONMARGINText": "Os traders de fundos devem manter em suas contas para manter uma negociação alavancada aberta. O termo geralmente se refere a fundos adicionais que devem ser depositados como resultado de movimentos de preços desfavoráveis.",
	"VOLATILITYVOL": "VOLATILIDADE (VOL)",
	"VOLATILITYVOLText": "Caracterizado por movimentos de preços rápidos e aleatórios, é um termo usado para se referir a mercados ativos que muitas vezes apresentam oportunidades comerciais.",
	"VOLUME_s": "VOLUME",
	"VOLUMEText": "Número total de contratos negociados durante um período específico.",
	"WeakDollarStrongDollar": "Dólar fraco/ dólar forte",
	"WeakDollarStrongDollarText": "O termo dólar fraco e forte é usado no mercado de câmbio para descrever o valor relativo e a força do dólar americano em relação a outras moedas. Diz-se que o dólar é fraco quando mais dólares são necessários para comprar uma unidade de outra moeda e forte quando poucos dólares são necessários para comprar uma unidade de outra moeda.",
	"Whipsaw": "Chicote",
	"WhipsawText": "Uma condição de extrema volatilidade quando o rápido crescimento de um preço é seguido por uma queda drástica (ou vice-versa).",
	"Yard": "Quintal",
	"YardText": "Prazo Forex para um bilhão de unidades",
	"YIELD": "RENDIMENTO",
	"YIELDText": "O rendimento obtido com um investimento.",
	"steps_heading1": "Informações Pessoais",
	"steps_heading2": "Declaração",
	"steps_heading3": "Carregar documentos pessoais",
	"step1_personalinfo": "Informações Pessoais",
	"step1_fname": "Primeiro Nome",
	"step1_age_error": "A faixa etária deve estar entre 18 e 80 anos",
	"step1_lname": "Sobrenome",
	"step1_dob": "DOB",
	"step1_dobrequired": "O DOB é necessário",
	"step1_below18": "Sua idade é abaixo de 18 anos",
	"step1_addinfo": "Informações de endereço",
	"step1_city": "Cidade",
	"step1_postalcode": "Código Postal",
	"step1_countryRes": "País de residência",
	"step1_otherinfo": "Outras Informações",
	"step1_addInfo": "Informações adicionais",
	"step1_phno": "Número de telefone",
	"step1_phnoRequired": "O número de telefone é obrigatório",
	"step1_correctno": "Por favor, digite o número de telefone correto",
	"step1_prefcurrency": "Selecione a moeda preferida da carteira",
	"step1_pep": "Você é uma Pessoa Politicamente Exposta (PEP)?",
	"step1_usPerson": "Você é uma pessoa dos EUA?",
	"step1_Next": "Próximo",
	"step1_firstmember": "Informações sobre o primeiro membro",
	"step1_member1dob": "Membro 1 Data de Nascimento é necessária",
	"step1_member1age": "Membro 1 Idade inferior a 18 anos",
	"step1_secondmember": "Informações sobre o segundo membro",
	"step1_menber2dobreq": "Membro 2 Data de Nascimento é necessária",
	"step1_member2age": "Membro 2 Idade inferior a 18 anos",
	"step1_adressinfo": "Informações de endereço",
	"step1_companyinfo": "Informações da Empresa",
	"step1_companyname": "Nome da Empresa",
	"step1_incopDate": "Data de constituição do mercado",
	"step1_incodateReq": "A Data de Incorporação é obrigatória",
	"step1_futuredate": "Data futura não permitida",
	"step1_authorperson": "Informações sobre pessoas autorizadas",
	"step1_companyAdrsinfo": "Informações de endereço da empresa",
	"step1_regAddone": "Endereço da Empresa Registada Linha 1",
	"step1_regAddtwo": "Endereço da Empresa Registada Linha 2",
	"step1_country": "País",
	"step1_minimumph": "O número de telefone inclui pelo menos 8 caracteres",
	"step1_maxphone": "O número de telefone não pode ter mais de 15 caracteres",
	"step1_stepMsz2": "Um PEP é uma pessoa física a quem foram confiadas as seguintes funções públicas proeminentes em qualquer país, bem como seus familiares diretos e pessoas conhecidas por serem associadas próximas de tal pessoa",
	"step1_stepMsz3": "A definição de pessoa dos EUA pessoa dos Estados Unidos inclui",
	"step2_financialDetails": "Detalhes Financeiros",
	"step2_txt1": "Se empregado, por favor especifique",
	"step2_txt2": "Rendimento Anual Estimado (USD)",
	"step2_txt3": "Património estimado (USD)",
	"step2_txt4": "Fonte de Recursos",
	"step2_txt5": "Salvar & Continuar",
	"step2_txt6": "Emprego",
	"step2_txt7": "Herança",
	"step2_txt8": "Investimento",
	"step2_txt9": "Imobiliário",
	"step2_txt10": "Poupança",
	"step2_txt11": "Outros",
	"step3_Questions": "Perguntas",
	"step3_txt1": "Vamos testar sua experiência de negociação",
	"step3_txt2": "Como uma entidade regulamentada, somos obrigados a avaliar se você tem compreensão apropriada para negociar produtos alavancados. Por favor, complete seu teste de adequação cuidadosamente, pois suas respostas serão usadas para determinar se você pode abrir uma conta de negociação ao vivo conosco.",
	"step3_txt3": "Iniciar teste",
	"step4_readaccept": "Li, entendi e aceito",
	"step4_ClientAgreement": "Contrato do Cliente",
	"step4_privacyplicy": "Política de Privacidade",
	"step4_and": "e",
	"step4_riskDisclosr": "Documentos de divulgação de riscos",
	"step4_termsAgreeRqd": "Por favor, concorde com estes termos",
	"step4_policytwo": "Concordo que meus dados pessoais sejam processados e armazenados de acordo com a Política de Privacidade e que a Fxview entre em contato comigo sobre informações importantes para minha conta",
	"step4_AfterCalling": "Observação",
	"step4_saveContinue": "Salvar & Continuar",
	"step4_allInfoCorrect": "Não será possível alterar nenhuma informação de etapa anterior. Certifique-se de que todas as informações estão corretas!",
	"step5_browsersupport": "Talvez o navegador esteja enfrentando algum problema técnico com a webcam",
	"step5_cameradenied": "Permissão da câmera negada",
	"step5_scanqrcode": "Digitalize o código QR em vez disso",
	"step5_scanqrmobile": "Escaneie este código QR usando sua câmera móvel ou aplicativo de código QR",
	"step5_keepageopen": "Por favor, mantenha esta página aberta enquanto estiver usando seu celular",
	"step5_continueBrowser": "Continuar com o navegador",
	"step5_docSubsuccess": "Seus documentos foram apresentados com sucesso. Por favor, seja paciente enquanto revisamos seus documentos e pode levar até 24 horas ou mais durante o horário de pico.",
	"step5_reviewstatus": "clique aqui para rever o estado do seu bilhete",
	"step5_identifyDoc": "DOCUMENTOS DE IDENTIDADE",
	"step5_proofresidence": "DOCUMENTOS COMPROVATIVOS DE RESIDÊNCIA",
	"step5_uploadphototext": "Carregue uma foto do seu documento de identidade. Certifique-se de que os detalhes no documento de identificação correspondem às informações que você inseriu no formulário de informações pessoais.",
	"step5_uploadproof": "Carregue um comprovante de endereço de residência (em seu nome e não mais de 6 meses de idade). Por favor, note que não aceitamos capturas de tela.",
	"step5_takephoto": "Tire uma foto da sua Carteira de Habilitação e carregue-a aqui",
	"step5_takegovernid": "Tire uma foto do seu documento de identificação emitido pelo Governo e carregue-o aqui",
	"step5_goodQuality": "Boa qualidade",
	"step5_brightclear": "Brilhante e claro",
	"step5_note": "Observação",
	"step5_allcorner": "Todos os cantos do documento devem estar visíveis e o documento deve ser válido (não expirado)",
	"step5_allcorner1": " Deve mostrar seu nome completo, endereço residencial, instituição emissora e data de emissão. Todos os cantos do documento devem ser claramente visíveis.",
	"step5_uploadfrontside": "Por favor, carregue a parte frontal do seu documento",
	"step5_maximumfilesize": "O tamanho máximo dos arquivos pode ser carregado até ",
	"step5_maxfilesize": "O tamanho máximo de arquivo aceito é de até ",
	"step5_uploadbackside": "Carregue o verso do seu documento",
	"step5_upload": "Carregar",
	"step5_idenfNumber": "Por favor, mencione seu número de identificação localizado em seu documento de identidade.",
	"step5_uploadpassport": "Tire uma foto do seu passaporte e carregue-o aqui",
	"step5_photolicense": "Tire uma foto da sua Carteira de Habilitação e carregue-a aqui",
	"step5_photogovernmentID": "Tire uma foto do seu documento de identificação emitido pelo Governo e carregue-o aqui",
	"step5_proofsixold": "Tire uma foto do seu comprovante ou residência (não mais de 6 meses)",
	"step5_bankstatement": "Extrato Bancário, Conta de Serviços Públicos (água, luz, internet residencial ou fixa), Documento Fiscal, Contrato de Locação (se emitido nos últimos 6 meses)",
	"step5_uploadyourDoc": "Carregue seu documento",
	"step5_idnorequired": "Número de identificação é obrigatório.",
	"step5_filesizemax": "o tamanho dos arquivos pode ser máximo",
	"step5_filesallowed": "Apenas arquivos jpg, jpeg, png, pdf são permitidos! ",
	"step5_uploadbothside": "Por favor, carregue ambos os lados do seu documento",
	"step5_verifydoc": "Por favor, carregue seu documento para verificar suas informações",
	"step5_continuemobile": "Continue com o celular",
	"step5_recentphoto": "Por favor, carregue sua foto recente",
	"step5_photoverif": "VERIFICAÇÃO DE FOTOS",
	"step5_legitimacy": "Todos os usuários são obrigados a fazer upload de uma foto de verificação. Isso é apenas parte das inúmeras técnicas e sistemas que empregamos para garantir a legitimidade de nossos usuários.",
	"step5_back": "voltar",
	"step5_start": "Use Webcam",
	"step5_TakeSelfie": "Tire uma selfie",
	"step5_webcamdont": "Continue com o celular",
	"step5_captureimage": "Capturar Imagem",
	"step5_cancel": "Cancelar",
	"step5_filemax": "o tamanho dos arquivos pode ser máximo de",
	"step5_choosefileupload": "Escolha o arquivo para carregar",
	"step5_allowmaxsize": "O tamanho máximo de arquivo que permitimos é de",
	"step5_useWebcam": "Use Web Cam",
	"soclTrade_zullutrade": "Zulu Comércio",
	"soclTrade_mql": "MQL5",
	"zulu_trade": "ZuluTrade",
	"zulu_zulitradeinfo": "Zulu trade é uma plataforma de negociação social onde você pode seguir comerciantes em todo o mundo e copiar negociações enquanto aprende com as estratégias que eles usam. Com base nas informações completas disponíveis para seus estilos de negociação e desempenho, você pode facilmente fazer os comerciantes de sua escolha e, uma vez que você segui-los, suas negociações serão automaticamente copiadas em sua conta.",
	"zulu_createAccount": "Criar Conta Zulu",
	"zulu_setupzulutrade": "Como configurar a conta ZuluTrade",
	"zulu_registeropen": "Registre-se e abra uma conta Fxview ZuluTrade.",
	"zulu_findaccount": "Financie a conta com um mínimo de $100 para receber credenciais de login da ZuluTrade.",
	"zulu_logintozulu": "Faça login no site de comércio zulu e comece a seguir qualquer comerciante de sua escolha.",
	"mampam_heading": "MAM/PAMM",
	"mampam_programenable": "O programa fxview MAM/PAMM permite que traders experientes gerenciem várias subcontas em uma única conta mestra, de maneira profissional.",
	"mampam_knowmore": "Saiba Mais",
	"mampam_becameinvestor": "Como se tornar um investidor",
	"mampam_clicktobecame": "Clique em `Torne-se um investidor`",
	"mampam_uniquepamid": "Insira o ID PAMM exclusivo do seu gerente para visualizar o perfil dele.",
	"mampam_createinverstor": "Crie sua conta de investidor e conecte-se com a conta PAMM",
	"mampam_monitoracc": "Monitore sua conta através do painel do investidor PAMM",
	"mampam_connectmanager": "Conecte-se a um gerente",
	"mampam_becomemanager": "Como se tornar um gestor",
	"mampam_clickbecomemanager": "Clique em tornar-se um gerente",
	"mampam_meetconditions": "Atenda às condições necessárias para receber seu ID PAMM exclusivo",
	"mampam_manageaccount": "Gerencie sua conta através do portal PAMM exclusivo",
	"mampam_becomeManager": "Torne-se um gerente",
	"mql_heading": "MQL5",
	"mql_text": "A MQL5 é uma das maiores comunidades de copy-trading do mundo, conectando traders novatos com experientes. Os usuários podem escolher entre milhares de sinais verificados gratuitos e sujeitos a taxas para melhorar seu desempenho de negociação",
	"mql_createliveAcc": "Criar Conta Real",
	"mql_stepsRegister": "Passos para registrar MQL5",
	"mql_stepone": "Registre uma conta MQL5 em seus sites",
	"mql_stepTwo": "Abra a plataforma Metatrader e vá em Ferramentas >> Opções e clique na guia Comunidade. Faça login na conta MQL5 e clique em OK.",
	"mql_stepThree": "Vá para a guia de sinais na janela do terminal e selecione o sinal que você deseja seguir.",
	"unaut_under": "Sob",
	"unaut_Verification": "Verificação",
	"unaut_pendingVerificationMsz1": "Seu pedido está sendo analisado pelo nosso departamento de compliance. Pode levar de 3 a 4 dias úteis para que seus documentos sejam verificados. Você receberá um e-mail assim que seus documentos forem verificados",
	"createzullu_Your": "O seu",
	"createzullu_successcreate": "A conta Zulu foi criada com sucesso. Suas credenciais são",
	"createzullu_accountBaseCurrency": "Moeda base da conta",
	"createzullu_tradenow": "Negocie agora",
	"fund_now": "Financiar Agora",
	"createzullu_forWeb": "Para a Web",
	"createzullu_open": "Aberto",
	"createzullu_tradingAcc": "Conta de Negociação",
	"createzullu_classic": "Clássico",
	"createzullu_profitsharing": "Participação nos Lucros",
	"createzullu_USD": "USD",
	"createzullu_EUR": "EUR",
	"createzullu_GBP": "GBP",
	"createzullu_AUD": "AUD",
	"createzullu_ZAR": "ZAR",
	"createzullu_leverageField": "Alavancagem é um campo obrigatório",
	"createzullu_accountPassword": "Senha da Conta de Negociação",
	"createzullu_passwordcontain": "Sua senha deve conter no mínimo 6 caracteres e no máximo 15 caracteres e incluir pelo menos 1 caractere especial (!@#$%^*/)",
	"createzullu_createAccount": "Criar Conta",
	"demoacc_demomsg": "A conta demo foi criada com sucesso. Suas credenciais são",
	"demoacc_MT4": "MetaTrader 4",
	"demoacc_MT5": "MetaTrader 5",
	"demoacc_passwordMust": "Sua senha deve conter no mínimo 6 caracteres e no máximo 24 caracteres e inclui pelo menos 1 caractere especial (!@#$%^*/) ",
	"liveacc_accounthas": "conta real tem sido ",
	"liveacc_successfully": "com sucesso",
	"liveacc_credentialsare": "Criou. Suas credenciais são",
	"wit_Wallet_from_wallet": "da carteira",
	"depMsz11": "Não é a conta certa do Skrill? Por favor",
	"wit_Wallet_Back": "De volta à carteira",
	"wit_Wallet_No": "Sem carteira",
	"wit_withdrawal": "Levantamentos",
	"wit_freeMargin": "Margem Livre",
	"wit_withdrawalMsz1": "Desculpe, você ainda não é elegível para um saque. Depositar e negociar pode ajudá-lo a se tornar elegível!",
	"wit_PrincipalWithAmount": "Montante de levantamento principal",
	"wit_AccNumber": "Número da conta",
	"wit_skrillId": "ID Skrill",
	"wit_netId": "Neteller ID",
	"wit_creditCardNumber": "número do cartão de crédito",
	"wit_expiryDate": "prazo de validade",
	"wit_allowOption": "Por favor, selecione uma das opções permitidas acima",
	"wit_WithdrawalMethodReq": "Método de retirada é necessário",
	"wit_EnterWithdrawal": "Entra em retirada",
	"wit_requestWithdrawal": "Você pode solicitar a retirada das opções de pagamento recém-aprovadas após 24 horas da aprovação",
	"wit_withdrawalMsz2": "Recebemos o seu pedido de levantamento e iremos atualizá-lo em conformidade",
	"wit_withCont1": "A Fxview não cobra taxas de retirada. No entanto, observe que os processadores de pagamento/intermediários financeiros podem cobrar uma taxa de transação.",
	"wit_withCont2": "Devido a restrições de transações de terceiros, os fundos só podem ser devolvidos para uma conta bancária no mesmo nome da sua conta de negociação Fxview. Além disso, os recursos só serão devolvidos para a mesma conta bancária de onde foram recebidos",
	"wit_withCont3": "O valor total que você pode sacar no seu cartão não pode exceder o valor total depositado com o cartão. Os montantes que excedam este nível podem ser levantados na sua conta bancária, Neteller ou Skrill",
	"withdraw_backWithdraw": "Voltar à retirada",
	"withdrawList": "Lista de Retirada",
	"withdrawList_all": "Todos",
	"withdrawList_pending": "Pendente",
	"withdrawList_processed": "Processado",
	"withdrawList_rejected": "Rejeitado",
	"withdrawList_created": "Data",
	"withdrawList_accountId": "ID da conta/número da carteira",
	"withdrawList_amount": "Quantidade",
	"withdrawList_currency": "Moeda",
	"withdrawList_withdrawalType": "Tipo de retirada",
	"withdrawList_method": "Método",
	"withdrawList_withdrawalStatus": "Status",
	"withdrawList_detail": "Detalhe",
	"withdrawList_viewTicket": "Ver Bilhete",
	"Wallet_Wallet": "Carteira",
	"Wallet_Loyalty_Points": "Pontos de Fidelidade",
	"Wal_detail_Add_New": "Adicionar nova moeda da carteira",
	"Wal_detail_Wallet_ID": "ID da carteira",
	"Wal_detail_Deposit": "Depósito",
	"Wal_detail_Withdraw": "Retirar",
	"Wal_detail_Transfer": "Transferência",
	"Wal_detail_curr_required": "O campo de moeda é obrigatório",
	"Wal_detail_Submit": "Submeter",
	"Wal_detail_Trans_History": "Histórico de transações",
	"Wal_detail_Date": "Data",
	"Wal_detail_Time": "Tempo",
	"Wal_detail_Type": "Tipo",
	"Wal_detail_From": "De",
	"Wal_detail_To": "Para",
	"Wal_detail_Amount": "Quantidade",
	"Wal_detail_Status": "Status",
	"Wal_detail_availAmount": "Quantidade disponível",
	"acc_fund_Deposit": "Depósito",
	"acc_fund_Withdrawal": "Desistência",
	"chang_wal_curr_Internal_Transf": "Transferência Interna da Carteira",
	"chang_wal_curr_Transf_Wall_amount": "Transferir valor da carteira",
	"chang_wal_curr_Back": "Voltar para a Carteira",
	"loyalP_Reward_Points": "Pontos de Recompensa de Fidelidade",
	"loyalP_Know_More": "Saiba Mais",
	"loyalP_Trans_Wallet": "Transferência para a Carteira",
	"loyalP_Transfer": "Transferência",
	"loyalP_transf_TotalP": "Total de pontos de fidelidade",
	"loyalP_transf_Amou_Avail": "Quantidade Disponível",
	"loyalP_transf_Enter_p_transfe": "Digite o ponto para transferir",
	"loyalP_transf_Cancel": "Cancelar",
	"loyalP_transf_Transfer": "Transferência",
	"loyalP_transf_Back": "Voltar para a Carteira",
	"loyalP_transToAcc": "Transferir para o ID da carteira",
	"loyalP_fieldReq": "Campo é obrigatório",
	"loyalP_fieldReq_min": "Mínimo de pontos de fidelidade resgatáveis = 100 pontos de fidelidade",
	"loyalP_intTransMsz2": "Por favor, clique no link para confirmar sua transferência interna",
	"loyalP_intTransMsz3": "A transferência foi concluída com êxito",
	"loyalP_fromTradId": "Do Trading ID",
	"loyalP_toTradId": "Para Trading ID",
	"loyalP_transferAmount": "montante transferido",
	"loyal_card_det_You_are_a": "Você é um",
	"loyal_card_det_member": "membro",
	"loyal_card_det_Points": "Pontos",
	"loyal_card_det_Last_Credit_On": "Último crédito em",
	"loyal_card_det_Earn": "Ganhe",
	"loyal_card_det_more_points_to_jump_to": "mais pontos para saltar",
	"loyal_card_det_gain_add_benefi": "para obter benefícios adicionais",
	"loyal_List_Trans_History": "Histórico de transações",
	"loyal_List_Date": "Data",
	"loyal_List_Activity": "Atividade",
	"loyal_List_Volume": "Volume",
	"loyal_List_Points": "Pontos",
	"loyal_List_Cr_Db": "Cr/Db",
	"loyal_ver_back": "Voltar para a Carteira",
	"redeamP_your_points": "Resgate seus pontos de fidelidade",
	"redeamP_Points": "Pontos",
	"redeamP_Redeem": "Resgatar",
	"redeamP_Red_Points": "Resgatar Pontos",
	"redeamP_Now": "Redima Agora",
	"redeamP_walletpoints": "Por favor, resgate pontos da carteira de acordo com os seguintes detalhes <br> pontos",
	"redeamP_pointdesc": "<br> point_desc",
	"tool_overview": "Visão geral",
	"tool_autochartistScan": "Scanner AutoChartist",
	"tool_autochartistWeb": "AutoChartist Web",
	"tool_Vpsheading": "VPS",
	"tool_ecoCalendar": "Calendário Econômico",
	"tool_tradingToolbox": "Caixa de Ferramentas do Trader",
	"tool_Calculator": "Calculadoras",
	"tool_tradingHOur": "Horário de Negociação",
	"tool_Signal": "Sinais",
	"autoScan_knoMore": "Saiba mais",
	"autoScan_DownLive": "Download para Conta Real",
	"autoScan_HowInstall": "Como instalar o AutoChartist",
	"autoScan_usrGuide": "guia do utilizador",
	"autoScan_goTool": "Na plataforma, vá para ferramentas > opções > consultores especialistas para permitir a importação de DLL e clique em OK.",
	"toolVps_sureImp": "Tem certeza de que vai implementar essa operação?",
	"toolVps_confirm": "confirmar",
	"toolVps_cancel": "cancelar",
	"toolVps_Shut_Down": "Desligamento",
	"toolVps_Restart": "Reiniciar",
	"toolVps_Reboot": "Reiniciar",
	"toolVps_Change_Pass": "Alterar senha",
	"toolVps_VieDet": "Ver Detalhe",
	"toolVps_UpdAcc": "Atualizar conta",
	"toolVps_Unsubscribe": "Cancelar inscrição",
	"toolVps_vpsList": "Lista de <span>Server</span>(VPS) privada virtual",
	"toolVps_createVps": "Criar VPS",
	"toolVps_SubList": "Lista de Assinaturas",
	"toolVps_accWalt": "Conta/Carteira",
	"toolVps_Priodicity": "Priodicidade",
	"toolVps_Price": "Preço",
	"toolVps_strtDate": "Data de início",
	"toolVps_endDate": "Data de Término",
	"toolVps_Action": "Ação",
	"toolVps_vps": "Virtual Private <span>Server</span>(VPS)",
	"toolVps_vpsTilte": "Desfrute de uma experiência de negociação inigualável conosco, onde a estabilidade de suas negociações é garantida. Não há mais necessidade de se preocupar com latência ou lidar com vários softwares em seu sistema. Use nosso VPS GRATUITO para obter respostas extremamente rápidas às suas negociações e desfrutar de velocidades impressionantes em nossas plataformas.",
	"toolVps_redLate": "Latência reduzida",
	"toolVps_freeOn5000": "Grátis com um depósito de $5.000 ou mais",
	"toolVps_remoteAcccess": "Acesso Remoto",
	"toolVpsstab_Env": "Ambiente Estável",
	"toolVps_back_vpsList": "Voltar à lista VPS",
	"toolVps_tc": "Aplicam-se os Termos e Condições",
	"toolVps_Plan": "Planejar",
	"toolVps_Status": "Status",
	"toolVps_type": "Tipo",
	"toolVps_nextpayment": "Próximo Pagamento",
	"toolVps_passWordMustContain12": "Sua senha deve conter pelo menos 12 caracteres e incluir pelo menos 1 número, 1 caractere maiúsculo e 1 caractere especial (!@#$%^&*/)",
	"toolVps_verifySubscribe": "Sua solicitação de atualização de conta de negociação foi processada com sucesso",
	"toolVps_back_subList": "Voltar à Lista de Assinaturas",
	"toolVps_reqProcessing": "processamento de pedidos...",
	"toolVps_reqVerify": "Solicitar verificação",
	"toolVps_reqFailed": "Falha na solicitação",
	"VpsSub_1_Record": "Você só tem um disco. Por favor, crie pelo menos mais uma conta de negociação ou carteira antes de tentar alterar uma conta de assinatura.",
	"VpsSub_liveAcc": "Conta Ativa",
	"VpsSub_Wallet": "Carteira",
	"VpsSub_ChangeTradAcc": "Alterar Conta de Negociação de Subscrição",
	"VpsSub_back_subLis": "Voltar à Lista de Assinaturas",
	"VpsSub_Submit": "Submeter",
	"VpsSub_received_request": "Recebemos o seu pedido de alteração de conta de negociação e iremos atualizá-lo em conformidade",
	"VpsSub_withdrawalAuthMessage": "Por favor, verifique o pedido de levantamento clicando no link que enviámos para o seu ID de e-mail registado",
	"VpsSub_noTradingAccFound": "Nenhuma conta de negociação ao vivo encontrada!",
	"VpsUnSub_1_record": "Você só tem um disco. Por favor, crie pelo menos mais uma conta de negociação ou carteira antes de tentar alterar uma conta de assinatura.",
	"VpsUnSub_liveAcc": "Conta Ativa",
	"VpsUnSub_Wallet": "Carteira",
	"VpsUnSub_sureUnsub": "Você tem certeza de cancelar a assinatura",
	"VpsUnSub_plan_": "Plano?",
	"VpsUnSub_confirm": "confirmar",
	"VpsUnSub_Cancel": "Cancelar",
	"VpsUnSub_received_request": "Recebemos o seu pedido de alteração de conta de negociação e iremos atualizá-lo em conformidade",
	"VpsUnSub_back_subList": "Voltar à Lista de Assinaturas",
	"VpsUnSubVer_successfully": "Sua solicitação de cancelamento de plano foi processada com sucesso",
	"VpsUnSubVer_back_subList": "Voltar à Lista de Assinaturas",
	"marktTrdHour_title": "Horário de Negociação do Mercado",
	"marktTrdHour_txt": "Nosso horário de servidor é GMT+3 durante o horário de verão dos EUA (DST) e GMT+2 durante o horário de verão dos EUA (não-horário de verão).",
	"marktTrdHour_table_below": "A tabela abaixo lista os horários de abertura e fechamento de vários instrumentos e classes de ativos de acordo com nosso tempo de servidor.",
	"marktTrdHour_Forex": "Forex",
	"marktTrdHour_Indices": "índices",
	"marktTrdHour_Commodities": "Commodities",
	"marktTrdHour_Open": "Aberto",
	"marktTrdHour_Close": "Fechar",
	"marktTrdHour_Break": "Intervalo",
	"trdMarktPlac_title": "Trader's <span>Market Place</span>",
	"trdMarktPlac_txt": "Navegue em nosso mercado para acessar estratégias criadas por alguns dos melhores traders do mundo, ou projete o seu próprio e vamos ajudá-lo a construí-lo. Nosso marketplace é um balcão único para levar sua negociação para o próximo nível.",
	"trdMarktPlac_Automate": "Automatize seu <span>trading</span> para tirar o máximo proveito dos mercados",
	"trdMarktPlac_Customise": "Personalize a sua negociação",
	"trdMarktPlac_Customise_Txt": "Defina seus requisitos e dê vida ao seu sistema conectando-se com um desenvolvedor que irá criá-lo para você",
	"trdMarktPlac_Risk_manag": "Gestão de riscos",
	"trdMarktPlac_Risk_manag_txt": "Analise o desempenho dos provedores de sinal com base em sua experiência, melhores e piores negociações, perfil de risco e muito mais",
	"trdMarktPlac_Browse_library": "Navegue pela nossa biblioteca",
	"trdMarktPlac_Browse_libraryTxt": "Navegue em nossa extensa biblioteca de EAs e indicadores para MT4, MT5 e ActTrader e encontre o ajuste certo para suas necessidades",
	"trdMarktPlac_Categories": "Categorias",
	"trdMarktPlac_All": "Todos",
	"trdMarktPlac_Expert": "Especialista",
	"trdMarktPlac_Advisors": "Conselheiros",
	"trdMarktPlac_Indicators": "Indicadores",
	"trdMarktPlac_ActTrader": "ActTrader",
	"trdMarktPlac_Popular": "Popular",
	"trdMarktPlac_New": "Novo",
	"trdMarktPlac_Free": "Grátis",
	"trdMarktPlac_Paid": "Pago",
	"trdMarktPlac_Long_Str": "Estratégias de Longo Prazo",
	"trdMarktPlac_2frame": "Dois quadros",
	"trdMarktPlac_StratCon2": "A estratégia consiste em dois gráficos diferentes",
	"trdMarktPlac_Details": "Detalhes",
	"trdMarktPlac_Add_List": "Adicionar à lista",
	"trdMarktPlac_Hammer_Ass": "Assistente de Martelo",
	"trdMarktPlac_Strat_trad_assis": "Esta Estratégia (assistente de negociação) irá avisá-lo quando um martelo está se formando e",
	"trdMarktPlac_Pos_Mgmt": "Gestão de Cargos",
	"trdMarktPlac_Lot_Cal": "Calculadora de lotes",
	"trdMarktPlac_Lot_Cal_txt": "Lot Calculator - é uma ferramenta Forex que permite calcular o tamanho do ...",
	"trdMarktPlac_Short_Strat": "Estratégias de Curto Prazo",
	"trdMarktPlac_Reg_Stra": "Estratégia de Regressão",
	"trdMarktPlac_Reg_StraTxt": "Estratégia abre uma posição de compra quando o baixo valor da vela atual é = top belt ..",
	"trdMarktPlac_NoData": "Sem dados",
	"ecoCalendar": "Calendário Econômico",
	"ecoCal_Title_Txt": "Acompanhe eventos econômicos importantes e lançamentos que impactam Forex, Commodities e Índices.",
	"ecoCal_Up_next": "Até a próxima",
	"ecoCal_Country": "País",
	"ecoCal_Select_All": "Selecione Tudo",
	"ecoCal_Clear": "Claro",
	"ecoCal_My_Filter": "Meu filtro",
	"ecoCal_Default": "Padrão",
	"ecoCal_Impact": "Impacto",
	"ecoCal_All": "Todos",
	"ecoCal_Medium": "Médio",
	"ecoCal_High": "Alto",
	"ecoCal_Save_filter": "Salvar configuração no meu filtro",
	"ecoCal_Apply_Filter": "Aplicar filtro",
	"ecoCal_Time": "Tempo",
	"ecoCal_TimeZ_Settings": "Configurações de fuso horário",
	"ecoCal_TimeZ": "Fuso Horário",
	"ecoCal_Select_TimeZ": "Selecione Fuso Horário",
	"ecoCal_TimeF": "Formato de Tempo",
	"ecoCal_Set_timeZ_Auto": "Definir meu fuso horário automaticamente",
	"ecoCal_Save_Sett": "Salvar configuração",
	"ecoCal_Cancel": "Cancelar",
	"ecoCal_noRecord": "Sem registro",
	"ecoCal_Event": "Evento",
	"ecoCal_Actual": "Real",
	"ecoCal_Forecast": "Previsão",
	"ecoCal_Previous": "Anterior",
	"tools_Trad_Tools": "Ferramentas de Negociação",
	"tools_Trad_Tools_Txt": "Tome decisões de investimento informadas e oportunas usando nossas poderosas ferramentas de negociação que ajudam você a identificar oportunidades potenciais e construir uma estratégia de negociação mais forte",
	"tools_Auto_Scanner": "Scanner AutoChartist",
	"tools_Auto_Scanner_txt": "Nunca mais perca uma oportunidade de negociação..",
	"tools_VPS": "VPS",
	"tools_VPS_txt": "Desfrute de VPS básico gratuito ou escolha entre a assinatura..",
	"tools_Eco_Calendar": "Calendário Econômico",
	"tools_Eco_Calendar_txt": "Mantenha-se atualizado sobre eventos econômicos importantes..",
	"tools_Trad_Toolbox": "Caixa de Ferramentas do Trader",
	"tools_Trad_Toolbox_txt": "Uma gama premium de ferramentas de negociação e análise..",
	"tools_Calculators": "Calculadoras",
	"tools_Calculators_txt": "Calcule o valor do pip, margem, swaps e mais..",
	"tools_TradeMarket": "Marketplace do Trader",
	"tools_TradeMarket_txt": "Encontre seu EA ou indicador ideal, ou tenha..",
	"tools_Trad_Hours": "Horário de Negociação",
	"tools_Trad_Hours_txt": "Veja rapidamente quando os mercados estão abertos..",
	"tools_Auto_Idea": "Ideia Autocartista",
	"tools_Auto_Idea_txt": "Nunca mais perca uma oportunidade de negociação..",
	"tools_readmore": "Leia mais",
	"tools_downloa": "baixar para",
	"MT4Demo": "MT4 Demo",
	"MT5Demo": "MT5 Demonstração",
	"toolor": "ou",
	"toolknowMore": "saiba mais",
	"chEn_entity": "Entidade",
	"chEn_global": "Fxview Global",
	"chEn_europe": "Fxview Europa",
	"chEn_redirectmsg1": "Com base na sua seleção de país de residência, você será redirecionado para o site da Charlgate Ltd., que está registrada no Chipre. Charlgate Ltd. enquadra-se no quadro regulamentar europeu, e está no âmbito da Diretiva dos Mercados de Instrumentos Financeiros II (MiFID II), entre outros. Além disso, está previsto um sistema de indemnização dos investidores.",
	"chEn_redirectmsg2": " ",
	"chEn_continue": "Continuar",
	"chEn_takeback": "Leve-me de volta",
	"adchart_create": "Criar",
	"adchart_save": "Salvar",
	"adchart_chart": "Gráfico",
	"adchart_Studies": "Estudos",
	"adchart_failedchart": "Falha ao carregar gráfico",
	"adchart_kindlyrefresh": "Por favor, atualize",
	"chart_loadchartfail": "Falha ao carregar o gráfico Gentilmente atualizar!",
	"filter_Selecttimezone": "Selecione Fuso horário",
	"filter_Low": "Baixa",
	"filter_medium": "Médio",
	"filter_high": "Alto",
	"filter_submit": "Submeter",
	"head_Wallet": "Carteira",
	"head_loyality": "Pontos de Lealdade",
	"head_createLiveAcc": "Criar Conta Real",
	"head_createDemoAcc": "Criar Conta Demo",
	"head_Notification": "Notificação",
	"head_seeAll": "Ver tudo",
	"head_noNewNotification": "Sem novas notificações",
	"head_verified": "Verificado",
	"head_notVerified": "Não verificado",
	"head_profile": "Perfil",
	"head_changePassword": "Alterar senha",
	"successMsz4": "Senha alterada com êxito",
	"head_security": "Segurança",
	"head_referFriend": "Indique um amigo",
	"head_logout": "Sair",
	"leftnav_dashboard": "Painel",
	"leftnav_wallet": "Carteira",
	"leftnav_accfunding": "Financiamento de contas",
	"leftnav_manageAcc": "Gerenciar conta",
	"leftnav_Depositbonus": "Bónus de Depósito",
	"leftnav_socialTrade": "Negociação Social",
	"leftnav_tools": "Ferramentas",
	"leftnav_education": "Educação &",
	"leftnav_resources": "Recursos",
	"leftnav_downloadplatform": "Plataforma de Download",
	"leftnav_support": "Apoio",
	"load_norecordfound": "Nenhum registro encontrado",
	"tradAcc_application": "Por favor, preencha seu pedido de conta e crie um",
	"tradAcc_application1": "Por favor, preencha o seu pedido de conta para aceder a esta função",
	"tradAcc_trading": "negociação",
	"tradAcc_live": "ao vivo",
	"tradAcc_accountAccess": "conta para acessar esta função.",
	"tradAcc_resumeApplication": "Solicitação de Retomada",
	"tradAcc_checkappStatus": "A sua candidatura está em análise, por favor verifique o estado do seu bilhete.",
	"tradAcc_ticket": "Bilhete",
	"tradAcc_createliveAcc": "Por favor, crie uma conta real para acessar esta função",
	"tradAcc_liveDemoAcc": "Por favor, crie uma conta real ou demo para acessar esta função",
	"tradAcc_demoAcc": "Conta Demo",
	"tradAcc_createWallet": "Por favor, crie uma carteira para acessar esta função",
	"tradAcc_wallet": "Carteira",
	"pagin_totalRecords": "Total de Registros",
	"acclist_fund": "Fundo",
	"acclist_addFund": "Adicionar fundos",
	"acclist_addFundTo": "Adicionar fundos a",
	"acclist_tradingId": "ID de negociação",
	"acclist_addingFundTo": "Adicionando fundos a",
	"acclist_tradingAcc": "",
	"acclist_fund_msz": "depósito bem-sucedido",
	"acclist_fund_mszErr": "depósito sem sucesso",
	"acclist_changeLeverage": "Alavancagem de Mudança",
	"acclist_changePassword": "Alterar senha",
	"acclist_internalTransfer": "Transferência interna",
	"acclist_tradeNow": "Negocie agora",
	"acclist_detachAcc": "Desanexar conta",
	"accId_TransFromAccId": "Transferência do ID da conta",
	"accId_selectAccountId": "Selecione o ID da conta",
	"accId_fieldReq": "Campo é obrigatório",
	"closetrad_login": "Login",
	"closetrad_order": "Ordem",
	"closetrad_symbol": "Símbolo",
	"closetrad_volume": "Volume",
	"closetrad_openPrice": "Preço Aberto",
	"closetrad_openTime": "Tempo Aberto",
	"closetrad_commision": "Comissão",
	"closetrad_type": "Tipo",
	"closetrad_SL": "SL",
	"closetrad_TP": "TP",
	"closetrad_closePrice": "Preço de fechamento",
	"closetrad_closeTime": "Hora de fechar",
	"closetrad_Swap": "Troca",
	"closetrad_PNL": "PNL",
	"closetrad_comment": "Comente",
	"closetrad_price": "Preço",
	"OCtradelist_balance": "Equilíbrio",
	"OCtradelist_margin": "Margem",
	"OCtradelist_equity": "Equidade",
	"OCtradelist_pnl": "PNL",
	"OCtradelist_tradeNow": "Negocie agora",
	"OCtradelist_opentrade": "Comércio Aberto",
	"OCtradelist_closetrade": "Fechar Comércio",
	"openOrder_orderId": "ID do pedido",
	"openOrder_accountId": "ID da conta",
	"openOrder_quantity": "Quantidade",
	"openOrder_triggered": "Acionado",
	"openOrder_side": "Lado",
	"openOrder_tradeId": "ID de comércio",
	"openOrder_profit": "Lucro",
	"openOrder_agentComm": "Comissão de agentes",
	"openOrder_cmd": "Cmd",
	"openOrder_sl": "SL",
	"openOrder_tp": "TP",
	"openOrder_swaps": "Trocas",
	"trade_cal_title": "Calculadoras de Negociação",
	"trade_cal_title_Txt": "Nossas calculadoras on-line fornecem uma maneira fácil de analisar as negociações que você planeja fazer. Ajudamo-lo a calcular valores com base nas condições de mercado e fornecemos-lhe resultados instantâneos.",
	"trade_cal_Commission": "Comissão",
	"trade_cal_Multi_Target": "Multi-Alvo",
	"trade_cal_Pivot_Points": "Pontos Dinâmicos",
	"trade_cal_Profit_Loss": "Lucro e Perda",
	"trade_cal_Fibonacci": "Fibonacci",
	"trade_cal_Pip_Value": "Valor do Pip",
	"trade_cal_Swap": "Troca",
	"trade_cal_Position_Size": "Tamanho da posição",
	"trade_cal_Currency_Convertor": "Conversor de Moeda",
	"cal_comm_title": "Comissão",
	"cal_comm_title_txt": "Calcule as comissões que você pagaria por uma negociação com nossa calculadora de comissões. A Fxview cobra uma comissão de US$ 1/100.000 em cada trajeto (ou US$ 2/100.000 ida e volta). Nossa calculadora de comissão irá ajudá-lo a calcular quanto isso funciona para, para qualquer negociação. Basta inserir a classe de ativos, o símbolo, a moeda base da conta e o tamanho da negociação e pressionar 'Calcular agora'",
	"cal_comm_forex": "Forex",
	"cal_comm_commodities": "mercadorias",
	"cal_comm_indices": "índices",
	"cal_comm_Asset_Class": "Classe de Ativos",
	"cal_comm_Field_req": "campo é obrigatório",
	"cal_comm_USD": "USD",
	"cal_comm_GBP": "GBP",
	"cal_comm_AUD": "AUD",
	"cal_comm_EUR": "EUR",
	"cal_comm_accBaseCurr": "Moeda base da conta",
	"cal_comm_Symbol": "Símbolo",
	"cal_comm_trade_size_lot": "Tamanho do comércio (em lotes)",
	"cal_comm_now": "Calcule agora",
	"cal_comm_Comm_roundT": "Comissão (ida e volta)",
	"cal_marg_title": "Margem",
	"cal_marg_title_txt": "A Calculadora de Margem ajuda a determinar a margem necessária para abrir uma posição. Basta selecionar a classe de ativos, o símbolo, a moeda da conta e o tamanho da negociação para determinar a margem necessária com base na alavancagem máxima oferecida para diferentes tipos de instrumentos.",
	"cal_marg_Field_req": "campo é obrigatório",
	"cal_marg_accBaseCurr": "Moeda base da conta",
	"cal_marg_Symbol": "Símbolo",
	"cal_marg_trade_size_lot": "Tamanho do comércio (em lotes)",
	"cal_marg_now": "Calcule agora",
	"cal_marg_req": "Margem exigida",
	"cal_marg_max_lev": "Alavancagem máxima",
	"cal_marg_forex": "Forex",
	"cal_marg_commodities": "Commodities",
	"cal_marg_indices": "índices",
	"cal_milti_Target": "Multi Alvo",
	"cal_milti_Target_txt": "Esta calculadora ajuda os traders a planejar qual parte de suas posições deve ser fechada em determinados níveis-alvo para obter a melhor relação retorno/risco possível.",
	"cal_milti_Field_req": "campo é obrigatório",
	"cal_milti_accBaseCurr": "Moeda base da conta",
	"cal_milti_Symbol": "Símbolo",
	"cal_milti_Position_Type": "Tipo de posição",
	"cal_milti_Buy": "Comprar",
	"cal_milti_Sell": "Vende",
	"cal_milti_Open_Price": "Preço Aberto",
	"cal_milti_Stop_loss_Price": "Preço de Stop Loss",
	"cal_milti_trade_size_lot": "Tamanho do comércio (em lotes)",
	"cal_milti_Target_Price": "Preço Alvo",
	"cal_milti_lots_Clos_Target": "lotes fechados no alvo",
	"cal_milti_Net_Lot_size": "Tamanho do lote líquido",
	"cal_milti_Now": "Calcule agora",
	"cal_milti_Target_Profit": "Meta de Lucro",
	"cal_milti_Total_Profit": "Lucro Total",
	"cal_milti_Return_Risk": "Retorno ao risco",
	"cal_pivot_point_txt": "A Fxview oferece uma calculadora de pontos de pivô para ajudá-lo a identificar a direção das tendências predominantes e determinar os níveis de suporte e resistência.",
	"cal_pivot_High": "Alto",
	"cal_pivot_Low": "Baixa",
	"cal_pivot_Open": "Aberto",
	"cal_pivot_Close": "Fechar",
	"cal_pivot_Calculate_Now": "Calcule agora",
	"cal_pivot_Clear": "Claro",
	"cal_pivot_CLASSIC": "CLÁSSICO",
	"cal_pivot_WOODIE": "WOODIE'S",
	"cal_pivot_CAMARILLA": "CAMARILLA",
	"cal_pivot_DMARKS": "DMARKS'S",
	"cal_pivot_Resistance": "Resistência",
	"cal_pivot_Pivot_Points": "Pontos Dinâmicos",
	"cal_pivot_Support": "Apoio",
	"cal_pivot_Field_req": "campo é obrigatório",
	"cal_pivot_PivotPoints": "Pontos Dinâmicos",
	"cal_profit_Loss": "Lucro e Perda",
	"cal_profitL_Txt": "A calculadora de lucros e perdas da Fxview é uma ferramenta básica que pode ajudá-lo a calcular o lucro ou a perda de uma negociação. Basta selecionar a classe de ativos, o símbolo, a moeda base da conta, os preços de abertura e fechamento desejados, o tipo de posição e o tamanho da negociação em lotes e pressionar 'Calcular agora'",
	"cal_profitLField_req": "campo é obrigatório",
	"cal_profitL_accBaseCurr": "Moeda base da conta",
	"cal_profitL_Symbol": "Símbolo",
	"cal_profitL_Pos_Type": "Tipo de posição",
	"cal_profitL_Buy": "Comprar",
	"cal_profitL_Sell": "Vende",
	"cal_profitL_Open_Price": "Preço Aberto",
	"cal_profitL_Close_Price": "Preço de fechamento",
	"cal_profitL_trade_size_lot": "Tamanho do comércio (em lotes)",
	"cal_profitL_Now": "Calcule agora",
	"cal_Fibonacci": "Fibonacci",
	"cal_fibo_txt": "Com a calculadora de fibonacci da fxview, você pode calcular as retrações de fibonacci com base nos pontos extremos de um gráfico em uma tendência de alta ou de baixa. Basta colocar os valores altos e baixos para começar.",
	"cal_fibo_Uptrend": "Tendência de alta",
	"cal_fibo_Downtrend": "Tendência de baixa",
	"cal_fibo_Field_req": "campo é obrigatório",
	"cal_fibo_High": "Alto",
	"cal_fibo_Low": "Baixa",
	"cal_fibo_Now": "Calcule agora",
	"cal_fibo_Retracements": "Retrações",
	"cal_fibo_Support": "Apoio",
	"cal_Pip_Value": "Valor do Pip",
	"cal_Pip_txt": "Uma ferramenta eficaz para gerenciar sua estratégia de risco, nossa calculadora de valor de pip permite calcular o valor por pip de cada posição. Com esta ferramenta você pode monitorar seu risco para cada negociação com mais precisão.",
	"cal_Pip_Field_req": "campo é obrigatório",
	"cal_Pip_accBaseCurr": "Moeda base da conta",
	"cal_Pip_Symbol": "Símbolo",
	"cal_Pip_trade_size_lot": "Tamanho do comércio (em lotes)",
	"cal_Pip_Now": "Calcule agora",
	"cal_swap": "Troca",
	"cal_swap_txt": "Os swaps podem ser pensados como o custo de financiamento de manter uma posição aberta. Eles podem ser positivos ou negativos, são pagos/recebidos quando uma posição é mantida aberta durante a noite. Eles são diferentes para posições longas e curtas, e variam entre diferentes instrumentos.",
	"cal_swap_MT4_MT5": "MT4/MT5",
	"cal_swap_ACT": "AGIR",
	"cal_swap_Field_req": "campo é obrigatório",
	"cal_swap_accBaseCurr": "Moeda base da conta",
	"cal_swap_Symbol": "Símbolo",
	"cal_swap_Num_Days": "Número de Dias",
	"cal_swap_trade_size_lot": "Tamanho do comércio (em lotes)",
	"cal_swap_Swap_Long": ">Troca longa",
	"cal_swap_Swap_Short": "Troca curta",
	"cal_Position_Size": "Tamanho da posição",
	"cal_position_txt": "A calculadora de tamanho de posição da Fxview ajuda a calcular quantos lotes de uma posição você pode abrir, dada uma quantidade pré-determinada que você está disposto a arriscar perder. Basta especificar a classe de ativos, a moeda base da conta, o símbolo, o tipo de posição, o preço de abertura e o stop loss, o saldo da conta e a porcentagem de risco (ou seja, a porcentagem do saldo da sua conta que você está disposto a correr o risco de perder) e pressione 'Calcular agora'",
	"cal_position_Field_req": "campo é obrigatório",
	"cal_position_accBaseCurr": "Moeda base da conta",
	"cal_position_Symbol": "Símbolo",
	"cal_position_Position_Type": "Tipo de posição",
	"cal_position_BUY": "COMPRAR",
	"cal_position_SELL": "VENDER",
	"cal_position_Open_Price": "Preço Aberto",
	"cal_position_Account_Balance": "Saldo da Conta",
	"cal_position_Stop_Loss": "Stop Loss",
	"cal_position_Risk_Perc": "Percentagem de risco",
	"cal_position_trade_size_lot": "Negocie em lotes",
	"cal_position_Now": "Calcule agora",
	"cal_curr_Convertor": "Conversor de Moeda",
	"cal_curr_conv_txt": "O conversor de moeda da Fxview permite que os usuários verifiquem o valor de uma moeda em relação a outras com base nas taxas de câmbio atuais. Com o nosso conversor de moedas, você pode converter quaisquer duas moedas com apenas alguns cliques.",
	"cal_curr_conv_From": "Moeda de",
	"cal_curr_conv_To": "Moeda para",
	"cal_curr_conv_Amount": "Quantidade",
	"cal_curr_conv_Field_req": "campo é obrigatório",
	"cal_curr_conv_Now": "Calcule agora",
	"cal_curr_conv_Converted": "Moeda convertida",
	"cal_leftmenu_commision": "Comissão",
	"cal_leftmenu_margin": "Margem",
	"cal_leftmenu_multiTarget": "Multi-Alvo",
	"cal_leftmenu_pivotpoints": "Pontos Dinâmicos",
	"cal_leftmenu_profitloss": "Lucro e Perda",
	"cal_leftmenu_fibonacci": "Fibonacci",
	"cal_leftmenu_pipValue": "Valor do Pip",
	"cal_leftmenu_Swap": "Troca",
	"cal_leftmenu_positionSize": "Tamanho da posição",
	"cal_leftmenu_currencyConv": "Conversor de Moeda",
	"suppIndex_requestServices": "Apoio",
	"suppIndex_OpenRequests": "Ingressos Abertos",
	"suppIndex_ClosedRequests": "Ingressos Fechados",
	"suppReqService_support": "Apoio",
	"suppReqService_howassist": "Como podemos ajudá-lo?",
	"suppReqService_emailus": "Envie-nos um e-mail",
	"suppReqService_email": "info@fxview.com",
	"suppReqService_liveChat": "Bate-papo ao vivo",
	"suppReqService_avail24": "Disponível 24/5",
	"suppReqService_requestcallback": "Solicitar Chamada de Volta",
	"suppReqService_office": "Escritório",
	"suppReqService_support_phn": "Apoio",
	"suppReqService_createTicket": "Criar um ticket de suporte",
	"suppReqService_helpSupport": "Como podemos ajudar?",
	"suppReqService_back": "Voltar",
	"suppReqService_AddPaymentMethod": "Adicionar Forma de Pagamento",
	"ZULU": "ZULU",
	"MQL5": "MQL5",
	"depositBonus": "Bónus de Depósito",
	"referfriend": "Indique um Amigo",
	"supp_Wallet": "Carteira",
	"contactReq": "O tempo de contato é necessário.",
	"support_ticketNumber": "Número do bilhete",
	"support_reason": "Razão",
	"support_created": "Data",
	"support_action": "Ação",
	"suppview_backToTicket": "Casa de Apoio",
	"suppview_thankyou": "Obrigado por verificar sua identidade e bem-vindo à Fxview! Agora você pode abrir uma conta de negociação ao vivo e começar a negociar.",
	"suppview_createliveAcc": "criar conta real",
	"suppview_whilevalidate1": "Ao validar seu documento de comprovação de endereço, notamos que o endereço e o número de identificação inseridos durante o cadastro não correspondem ao documento carregado durante a verificação.",
	"suppview_whilevalidate2": "Ao validar seu documento de comprovação de endereço, notamos que o endereço inserido durante o cadastro não corresponde ao documento carregado durante a verificação.",
	"suppview_whilevalidate3": "Ao validar seu documento de comprovação de endereço, notamos que o número de identificação inserido durante o cadastro não corresponde ao documento carregado durante a verificação.",
	"suppview_originalAdress": "Endereço original",
	"suppview_stepMsz18": "Não quero mudar nada",
	"suppview_preQues": "Pergunta anterior",
	"suppview_nextQues": "Próxima pergunta",
	"suppview_stepMsz21": "Resolver conflitos",
	"suppview_idNumEnt": "Número de identificação introduzido",
	"suppview_percentComplete": "% Concluído",
	"suppview_nationalityEntered": "Nacionalidade inscrita",
	"suppview_fillone": "Por favor, preencha pelo menos um campo",
	"otpVerif_otpVerification": "Verificação OTP",
	"otpVerif_otpVerificationText1": "Um Pin Único foi enviado para o seu e-mail.",
	"otpVerif_resendOtpTicket": "Não recebeu um e-mail em sua caixa de entrada ou pasta de spam? Reenviar",
	"otpVerif_back": "voltar",
	"otpVerif_backToTicket": "Casa de Apoio",
	"profileReq_getHelpWith": "Obtenha ajuda com",
	"profileReq_Queries": "Consultas relacionadas",
	"profileReq_relatedTopics": "Tópicos relacionados",
	"profileReq_inversterPass": "No caso de você enfrentar quaisquer problemas para definir a senha do investidor a partir de sua plataforma MT4/MT5, por favor, prossiga com a criação da solicitação de suporte",
	"profileReq_notSatisfied": "Não estou satisfeito",
	"profileReq_lodgeComplaint": "Apresentar uma reclamação",
	"profileReq_helpUsWithYour": "Ajude-nos com o seu",
	"profileReq_askOtherQuestions": "Faça-nos qualquer outra pergunta",
	"profileReq_AddBankDetails": "Adicionar dados bancários",
	"profileReq_AddSkrillDetails": "Adicionar detalhes do Skrill Id",
	"profileReq_AddNetellerDetails": "Adicionar detalhes do Neteller Id",
	"profileReq_AddCreditCardDetails": "Adicionar detalhes do cartão de crédito",
	"profileReq_inn": "em",
	"profileReq_emailHeading": "Por favor, digite seu novo ID de e-mail abaixo",
	"profileReq_exsistsEmailAddress": "Endereço de e-mail existente",
	"profileReq_newEmail": "Digite seu novo endereço de e-mail",
	"profileReq_EmailfieldValid": "Introduza um endereço de e-mail válido",
	"profileReq_EmailfieldReq": "O campo de e-mail é obrigatório",
	"profileReq_changeEmailAddress": "Alterar endereço de e-mail",
	"profileReq_mobileHeading": "Por favor, digite seu novo número de celular abaixo",
	"profileReq_existingMobileNumber": "Número de telemóvel existente",
	"profileReq_InvalidNumber": "Número inválido",
	"profileReq_changeMobileNumber": "Alterar número de telemóvel",
	"profileReq_postCodeRequired": "O código postal é obrigatório",
	"profileReq_residenceCountryRequired": "O país de residência é obrigatório",
	"profileReq_uploadRecentAddressProof": "Carregar comprovante de endereço recente",
	"profileReq_docReq": "documento é necessário",
	"profileReq_changeAddress": "Alterar Endereço",
	"profileReq_bankName": "Nome do banco",
	"profileReq_AccountName": "Nome da conta",
	"profileReq_bankNameRequired": "O nome do banco é obrigatório",
	"profileReq_accountHolderRequired": "O nome do titular da conta é obrigatório",
	"profileReq_AccNumber": "Número da conta",
	"profileReq_accountNumberRequired": "O número da conta é obrigatório",
	"profileReq_country": "País",
	"profileReq_countryFieldRequired": "O campo país é obrigatório",
	"profileReq_IBAN": "IBAN",
	"profileReq_ibanRequired": "O iban é necessário",
	"profileReq_MyBankNotIBAN": "O meu banco não emite IBAN",
	"profileReq_SwiftCode": "Swift/BIC/Código de classificação",
	"profileReq_swiftCodeRequired": "O código swift é necessário",
	"profileReq_bankAdd": "Endereço do banco",
	"profileReq_bankAddressRequired": "O endereço do banco é obrigatório",
	"profileReq_UpBankStatement": "Carregar extrato bancário",
	"profileReq_fileallow": "Somente arquivos jpg, jpeg, png, pdf, docx, doc, xls, xlsx são permitidos!",
	"profileReq_addNewBank": "Adicionar uma nova conta bancária",
	"profileReq_last4Digit": "últimos 4 dígitos são necessários e contém apenas caracteres numéricos",
	"profileReq_first4Digit": "os primeiros 4 dígitos são necessários e contêm apenas caracteres numéricos",
	"profileReq_frontBack": "Exigimos o seguinte para a verificação do cartão -",
	"profileReq_frontPhotoCredit": "Cópia colorida da parte frontal do cartão, mostrando",
	"profileReq_uploadSupportingDocument": "Carregar um documento de apoio",
	"profileReq_backPhotoCredit": "Cópia colorida do verso do cartão escondendo o código de segurança do CVV. O verso deve conter o sinal do titular",
	"profileReq_submit": "Submeter",
	"profileReq_paymentRequiredNumeric": "O campo ID de pagamento é obrigatório e só pode conter caracteres numéricos.",
	"profileReq_netSkrill1": "por favor, carregue a captura de tela do",
	"profileReq_netSkrill2": "perfil com contato com o nome completo,",
	"profileReq_netSkrill3": "Identificação e endereço. Vamos combinar o nome e o endereço",
	"profileReq_userDetails": "Detalhes do Usuário",
	"profileReq_ComplaintDetails": "Detalhes da Reclamação",
	"profileReq_employeeWhoOffered": "Funcionário que ofereceu os serviços ao cliente",
	"profileReq_timeDisputed": "Data e hora da situação contestada (no horário do servidor MetaTrader)",
	"profileReq_TheDisputeTime": "O tempo de disputa é necessário",
	"profileReq_ticNoContested": "Número(s) de bilhete de todas as posições contestadas e/ou ordens pendentes",
	"profileReq_DisputedAmount": "Valor contestado",
	"profileReq_reportComplaint": "Comunicou a sua queixa a alguma Autoridade de Supervisão?",
	"profileReq_stateNameAuth": "Indique o nome da Autoridade de Supervisão",
	"profileReq_TheAuthorityName": "O nome da autoridade é obrigatório",
	"profileReq_DetailedDescript": "Descrição detalhada da Denúncia",
	"profileReq_attachTogetherForm": "Por favor, anexe junto com este formulário qualquer evidência de apoio à sua reivindicação que facilite a investigação de sua reclamação. As provas de apoio podem consistir em qualquer documentação (capturas de tela, chats, registros telefônicos etc.) relevantes para a denúncia.",
	"profileReq_Subject": "Assunto",
	"profileReq_yourMsz": "Sua Mensagem",
	"profileReq_ticketHasbeenComplaint": "Sua reclamação foi registrada com sucesso",
	"profileReq_ticketHasbeenCreated": "Seu ingresso foi criado",
	"profileReq_proMsz19": "Ir para Ingressos",
	"profileReq_entervalidcard": "introduza o número do cartão válido",
	"profileReq_changeEmail": "Por favor, altere meu e-mail conforme os seguintes detalhes <br> E-mail antigo",
	"profileReq_NEWEmail": "<br> Novo Email",
	"profileReq_changeMobile": "Por favor, altere meu número de celular conforme os seguintes detalhes <br> Número antigo",
	"profileReq_newNumber": "<br> Novo Número",
	"profileReq_changebankinfo": "Por favor, altere meus dados bancários conforme os seguintes detalhes <br> Número da conta",
	"profileReq_holdername": "Nome do Titular <br>",
	"profileReq_bankname": "Nome do Banco <br>",
	"profileReq_bankcode": "Código do Banco <br>",
	"profileReq_sortcode": "Código de classificação <br>",
	"profileReq_bankAddress": "Endereço do Banco <br>",
	"profileReq_changeadress": "Por favor, altere meu endereço conforme os seguintes detalhes <br> Address1",
	"profileReq_adresstwo": "Endereço <br>2",
	"profileReq_postcode": "Código Postal <br>",
	"profileReq_residenceCountry": "País de residência <br>",
	"profileReq_nation": "<br> Nacionalidade",
	"profileReq_City": "Cidade <br>",
	"profileReq_pleaseAdd": "Por favor, adicione",
	"profileReq_paymentmethod": "Forma de pagamento conforme seguintes dados <br>",
	"profileReq_number": "Número",
	"profileReq_expiryDate": "Prazo de validade",
	"profileReq_id": "Id",
	"autoscan_AutochartistScanner": "Scanner AutoChartist",
	"autoscan_IBintegrateAdvancedTool": "O AutoChartist é um software de reconhecimento de padrões gráficos de primeira linha que verifica instrumentos de negociação e reconhece automaticamente as configurações de negociação com base em rupturas, retrações, suporte e níveis de resistência para que você nunca mais perca uma oportunidade.",
	"autoscan_closeMt4": "Faça login na sua conta fxview MT4.",
	"autoscan_DownloadRunAuto": "Baixe e execute o aplicativo AutoChartist Scanner.",
	"autoscan_SelectPortfoliosTrading": "Selecione fxview MT4 Platform e prossiga com a instalação.",
	"autoscan_RestartMt4Platform": "Reinicie a plataforma fxview MT4.",
	"autoscan_autochartistdesc": "Autochartist Scanner pode ser usado na conta MT4 ao vivo com um valor mínimo de depósito de US $ 200.",
	"autoscan_DisclaimerAutoChartist": "Isenção de responsabilidade",
	"autochar_autocharist": "Auto Cartista",
	"autochar_CreateLiveAccount": "Criar Conta Real",
	"autochar_Cancel": "Cancelar",
	"subVerf_reqVerify": "Solicitar verificação",
	"subVerf_dear": "Querido",
	"subVerf_your": "seu",
	"subVerf_accountVerMsz1": "o pedido foi processado com êxito",
	"subVerf_backSubList": "De volta às ferramentas de susbcription",
	"subtrans_heading": "Detalhe da Transação de Assinatura",
	"subtrans_date": "Data (criado)",
	"subtrans_payType": "Tipo de pagamento",
	"subtrans_planprice": "Preço do plano",
	"subtrans_coupon": "Cupom",
	"subtrans_amount": "Quantidade",
	"subtrans_noData": "sem dados",
	"subtrans_backVPSlist": "voltar à lista VPS",
	"vpsdetail_heading": "Detalhe VPS",
	"vpsdetail_IPAddress": "Endereço IP",
	"vpsdetail_ServerId": "ID do servidor",
	"vpsdetail_HostName": "Nome do anfitrião",
	"vpsdetail_Disk": "Disco",
	"vpsdetail_Cpu": "Cpu",
	"vpsdetail_Memory": "Memória",
	"vpsdetail_State": "Estado",
	"vpsdetail_Created": "Data",
	"vpsdetail_action": "Ação",
	"toolbox_tradeToolbox": "Caixa de Ferramentas do Trader",
	"toolbox_moreAboutTradeToolbox": "Saiba mais sobre a Toolr's Tool Box",
	"toolbox_tradeToolMsz1": "Enriqueça sua negociação com fxview Trader's Tool Box - um conjunto de indicadores e aplicativos robustos que adiciona conveniência à sua jornada de negociação.",
	"toolbox_WhatYouGet": "O que você ganha",
	"toolbox_TraderToolboxApp": "Aplicação Trader's Tool Box",
	"toolbox_TradeTerminal": "Terminal de Comércio",
	"toolbox_MiniTerminal": "Mini Terminal",
	"toolbox_AlarmsManager": "Gerenciador de Alarmes",
	"toolbox_ExcelRTD": "Excel RTD",
	"toolbox_Connect": "Conectar",
	"toolbox_SentimentTrader": "Comerciante de Sentimento",
	"toolbox_SessionMap": "Mapa da sessão",
	"toolbox_MarketManager": "Gerente de Mercado",
	"toolbox_CorrelationMatrix": "Matriz de Correlação",
	"toolbox_CorrelationTrader": "Trader de Correlação",
	"toolbox_TickTrader": "Tick Trader",
	"toolbox_StealthOrder": "Ordem furtiva",
	"toolbox_IndicatorPackage": "Pacote de indicadores",
	"toolbox_Minichart": "Mini gráfico",
	"toolbox_PivotPoints": "Pontos Dinâmicos",
	"toolbox_HighsLows": "Altos e baixos",
	"toolbox_Renkobars": "Bares Renko",
	"toolbox_ChartGroup": "Grupo de gráficos",
	"toolbox_SymbolInfo": "Informações do símbolo",
	"toolbox_Gravity": "Gravidade",
	"toolbox_Chart_in_Chart": "Gráfico no gráfico",
	"toolbox_PeriodConverter": "Conversor de Período",
	"toolbox_Magnifier": "Lupa",
	"toolbox_OrderHistory": "Histórico de Pedidos",
	"toolbox_FreehandDrawing": "Desenho à mão livre",
	"toolbox_BarChanger": "Bar Changer",
	"toolbox_KeltnerChannel": "Canal Keltner",
	"toolbox_DonchianChannel": "Canal Donchian",
	"toolbox_CandleCountdown": "Contagem regressiva de velas",
	"toolbox_LinearRegression": "Regressão Linear",
	"toolbox_howtoinstall": "COMO INSTALAR A CAIXA DE FERRAMENTAS DO TRADER",
	"toolbox_loginFxViewmt45": "Faça login na sua conta fxview MT4/5",
	"toolbox_ToolboxApplication": "Baixe e execute o aplicativo MT4/5 Trader's Tool Box",
	"toolbox_FxviewMT45installation": "Selecione fxview MT4/5 Platform e prossiga com a instalação",
	"toolbox_allowDdlImports": "Clique em ferramentas> opções> expert advisor> e depois clique em ok para permitir importações DDL",
	"toolbox_RestartFxviewMT45": "Reinicie a plataforma fxview MT4/5",
	"toolbox_tradeToolboxliveMinDeposit": "O aplicativo Trader's Tool Box pode ser usado na conta MT4/5 ao vivo com um valor mínimo de depósito de US $ 500.",
	"toolbox_DisclaimerAutoChartist": "Isenção de responsabilidade",
	"subscription_Subscriptionheading": "Assinaturas",
	"subscription_SubMsz": "Leve seu plano desejado para ter acesso ao nosso conteúdo facilmente, gostamos de oferecer oferta de licença especial para nossos usuários.",
	"subscription_mnth": "/mês",
	"subscription_freeMin": "GRÁTIS - MIN",
	"subscription_deposit": "Depósitos",
	"subscription_Features": "Características",
	"subscription_window": "janela",
	"subscription_Memory": "Memória",
	"subscription_ssdDisk": "DISCO SSD",
	"subscription_create": "Criar",
	"subticket_getSubPlan": "Obter assinatura para este plano",
	"subticket_applyCouponCode": "Código de cupom aplicado",
	"subticket_TotalAmount": "montante total",
	"subticket_havePromoCode": "Tem um código promocional?",
	"subticket_deducedMonthlySubscription": "Por favor, selecione o ID de negociação de onde você deseja que o custo seja deduzido para a assinatura mensal, caso as condições mínimas não sejam atendidas para VPS gratuito.",
	"subticket_demo": "Demonstração",
	"subticket_live": "Ao vivo",
	"subticket_noteUnsubTool": "Observação",
	"subticket_clickToAgree": "Clique aqui para concordar",
	"subticket_vpsTC": "VPS T&C.",
	"subticket_linkToSub": "Por favor, clique nesse link para se inscrever.",
	"subticket_subsucce": "foi inscrito com sucesso. Para saber mais detalhes, clique no botão abaixo",
	"subticket_AutoChartPage": "Ir para a página Auto Chartist",
	"subticket_controlsignalPage": "Ir para a página Control Signal",
	"subticket_researchReportpage": "Ir para a página de relatórios de pesquisa",
	"subticket_currentNewsPage": "Ir para a página de notícias atuais",
	"subticket_economicCalPage": "Ir para a página do calendário econômico",
	"subticket_vpsPage": "Ir para a página VPS",
	"subticket_selectPromoCode": "Selecione um código promocional",
	"subticket_EnterCouponCode": "Digite o código do cupom",
	"subticket_Apply": "Aplicar",
	"subticket_For": "Para",
	"subticket_noPromoCode": "Você ainda não tem nenhum código promocional!",
	"subticket_vpsSubPlan": "SUBSCRIÇÃO DO PLANO VPS",
	"subticket_createVPS": "Por favor, adicione fundos para criar VPS",
	"subticket_goDepositPage": "Ir para a página de depósito",
	"noTradingCreateNewOne": "Ainda sem conta de negociação, crie uma nova conta",
	"faMszOtp1": "ou usar também pode usar 2fa OTP, mas você deve ativar primeiro clicando no link abaixo",
	"RESEND_EMAIL": "Reenviar e-mail",
	"TECH_ERROR": "Estamos enfrentando alguns problemas, por favor, tente depois de algum tempo",
	"VALIDATION_ERROR": "erro de validação",
	"INVALID_TRADING_ACC": "erro inválido da conta de negociação",
	"INVALID_WITHDRAWAL_TRANSACTION": "operação de levantamento inválida",
	"INVALID_OTP": "OTP inválida",
	"FILE_UPLOAD": "Apenas arquivos jpg, jpeg, png, pdf são permitidos!",
	"OTP_EXPIRED": "OTP expirou",
	"OTP_IP_MISMATCH": "OTP não é match",
	"LOW_BALANCE_THEN_AMOUNT": "O valor que você inseriu é maior do que a Margem Livre disponível.",
	"TICKET_EXIST": "bilhete já existe",
	"EMAIL_EXIST": "o e-mail já existe",
	"MOBILE_EXIST": "número de telemóvel já existe",
	"LOW_BONUS_THEN_AMOUNT": "valor que você preencheu é baixo então seu bônus",
	"INVALID_ACCOUNT_TRANSACTION": "transação de conta inválida",
	"INVALID_TICKET_TRANSACTION": "transação de bilhete inválida",
	"DEPOSIT_LIMIT": "limite de depósito",
	"AMOUNT_GREATER_THEN_ALLOWED": "O valor que você inseriu é maior do que o permitido.",
	"fund_msz": "depósito com sucesso",
	"suceessMsz1": "2FA ativado com sucesso",
	"suceessMsz2": "2FA desativado com sucesso",
	"suceessMsz3": "Um link para alterar senha foi enviado em seu ID de e-mail registrado",
	"suceessMsz4": "Senha alterada com sucesso",
	"suceessMsz5": "OTP reenviar com sucesso",
	"suceessMsz6": "OTP é enviado em seu e-mail de registro e número de celular",
	"suceessMsz7": "Agora você está qualificado para abrir uma conta real",
	"suceessMsz8": "por favor, carregue o seu documento no prazo de 15 dias",
	"suceessMsz9": "adicionar nome com sucesso",
	"suceessMsz10": "link foi enviado seu ID de e-mail registrado",
	"suceessMsz11": "plano cancelar inscrição com sucesso",
	"suceessMsz12": "reinicialização do serviço com êxito",
	"suceessMsz13": "reinicialização do serviço com êxito",
	"suceessMsz14": "desligamento bem-sucedido do serviço",
	"suceessMsz15": "senha de serviço alterada com êxito",
	"suceessMsz16": "Foi enviado um link para o seu endereço de e-mail registado",
	"suceessMsz17": "depósito com sucesso",
	"suceessMsz18": "OTP reenviar com sucesso",
	"suceessMsz19": "adicionar banco com sucesso",
	"suceessMsz20": "bilhete foi criado com sucesso e aguarde 2-3 dias úteis",
	"suceessMsz21": "Neste momento estamos permitindo apenas 1.00.000.00. Caso queira depositar mais do que isso, por favor, entre em contato com o suporte",
	"suceessMsz22": "você não está autorizado a inserir valor maior ou igual ao limite de depósito - , porque você ainda não está verificado e seu documento ainda está em verificação, então você não pode depositar mais de 2000 EUR",
	"suceessMsz23": "Montante inválido",
	"suceessMsz24": "Sua conta não foi verificada",
	"suceessMsz25": "ID da conta deve ser diferente de outra ID da conta que você selecionou",
	"suceessMsz26": "pelo menos selecione 2 opções",
	"suceessMsz27": "nova senha não é o mesmo que confirmar nova senha",
	"suceessMsz28": "Sua senha deve conter pelo menos 6 caracteres e incluir pelo menos 1 número, 1 caractere maiúsculo e 1 caractere especial (!@#$%^&*/)",
	"suceessMsz29": "",
	"errorMsz1": "Desculpa! Este link foi extinto. Clique em <router-link"
}


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/pt.js